webpackJsonp([5],Array(18).concat([
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c61c275_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(249);
function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c61c275"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c61c275_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f195b8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f195b8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672983da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(306);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(14)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-672983da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672983da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.3e80392.gif";

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var getQuantity = function getQuantity(arr) {
  var count = 0;
  for (var i in arr) {
    if (arr[i].quantity) {
      count += arr[i].quantity;
    }
  }
  return count;
};

var getToken = function getToken() {
  if (localStorage.user) {
    var localUser = JSON.parse(localStorage.user);
    return localUser.uid;
  }
  var currentUser = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;
  return currentUser ? currentUser.uid : null;
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  data: function data() {
    return {
      authenticated: false
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('checkUserStatus');
  },

  computed: {
    userIsLogged: function userIsLogged() {
      var user = this.$store.getters.user || localStorage.getItem('user');
      if (user) {
        this.setAuthenticated(true);
      } else {
        this.setAuthenticated(false);
        var currentRoute = this.$router.currentRoute;
        this.$router.replace({ name: currentRoute.name });
      }
      return user;
    }
  },
  watch: {
    userIsLogged: function userIsLogged(value) {
      if (value === null || value === undefined) {
        this.setAuthenticated(false);
      }
    },
    authenticated: function authenticated(value) {
      if (value === false) {
        this.$router.replace({ name: 'login' });
      }
    }
  },
  methods: {
    setAuthenticated: function setAuthenticated(status) {
      this.authenticated = status;
    },
    logout: function logout() {
      if (this.authenticated) {
        this.$store.dispatch('userLogout');
        this.setAuthenticated(false);
      }
    }
  }
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      error: '',
      loading: false
    };
  },
  mounted: function mounted() {
    // this.$store.dispatch('fetchUser')
    this.$store.dispatch('checkUserStatus');
  },

  computed: {
    isLogged: function isLogged() {
      var user = this.$store.getters.user || localStorage.getItem('user');
      if (user) {
        this.$emit('authenticated', true);
        this.$router.replace({ name: 'home' });
      }
      return user;
    },
    haveError: function haveError() {
      return this.$store.getters.error;
    }
  },
  watch: {
    haveError: function haveError(value) {
      this.loading = false;
      this.error = value;
    },
    isLogged: function isLogged(value) {
      // console.log('LOGIN isLogged', value)
    }
  },
  methods: {
    login: function login() {
      this.loading = true;
      this.$store.dispatch('userLogin', { email: this.email, password: this.password });
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      displayName: null,
      photoURL: null,
      email: null,
      password: null,
      error: null,
      loading: false
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('checkUserStatus');
  },

  computed: {
    isLogged: function isLogged() {
      var user = this.$store.getters.user || localStorage.getItem('user');
      if (user) {
        this.$emit('authenticated', true);
        this.$router.replace({ name: 'home' });
      }
      return user;
    },
    haveError: function haveError() {
      return this.$store.getters.error;
    }
  },
  watch: {
    haveError: function haveError(value) {
      this.loading = false;
      this.error = value;
    },
    isLogged: function isLogged(value) {
      // console.log('LOGIN isLogged', value)
    }
  },
  methods: {
    selectPhotoURL: function selectPhotoURL(photoURL) {
      this.photoURL = photoURL;
    },
    register: function register() {
      if (this.displayName && this.email && this.password && this.photoURL) {
        this.loading = true;
        this.$store.dispatch('userRegister', {
          email: this.email,
          password: this.password,
          displayName: this.displayName,
          photoURL: this.photoURL
        });
      }
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amcharts_amcharts4_core__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amcharts_amcharts4_maps__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_themes_animated__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_geodata_worldLow__ = __webpack_require__(301);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2__amcharts_amcharts4_core__["b" /* useTheme */](__WEBPACK_IMPORTED_MODULE_4__amcharts_amcharts4_themes_animated__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      amcharts: []
    };
  },

  computed: {
    layout: function layout() {
      /* if (!this.$store.getters.user || !localStorage.getItem('user')) {
        this.$router.replace({ name: 'login' })
      } */
      return 'Layout';
    },
    banknotesCount: function banknotesCount() {
      return this.$store.getters.banknotesCount;
    },
    coinsCount: function coinsCount() {
      return this.$store.getters.coinsCount;
    },
    coinsBanknotesByContinent: function coinsBanknotesByContinent() {
      return this.$store.getters.coinsBanknotesByContinent;
    },

    // countriesAmcharts () {
    //   return this.$store.getters.countriesAmcharts
    // },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    // this.$store.dispatch('fetchCountriesAmcharts')
    this.$store.dispatch('fetchCountries');
    this.$store.dispatch('fetchCoinsCount');
    this.$store.dispatch('fetchBanknotesCount');
    this.$store.dispatch('fetchCoinsBanknotesByContinent');
  },
  mounted: function mounted() {
    // this.initAmcharts()
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart2) {
      this.chart2.dispose();
    }
  },

  methods: {
    goToCoinsContinent: function goToCoinsContinent(codeContinent) {
      this.$router.replace({ name: 'coin.continent', params: { code: codeContinent.toLowerCase() } });
    },
    goToBanknotesContinent: function goToBanknotesContinent(codeContinent) {
      this.$router.replace({ name: 'banknote.continent', params: { code: codeContinent.toLowerCase() } });
    },
    logout: function logout() {
      this.$parent.logout();
    },
    initAmcharts: function initAmcharts() {
      // create map
      var chart2 = __WEBPACK_IMPORTED_MODULE_2__amcharts_amcharts4_core__["a" /* create */](this.$refs.chartdiv, __WEBPACK_IMPORTED_MODULE_3__amcharts_amcharts4_maps__["a" /* MapChart */]);
      chart2.geodata = __WEBPACK_IMPORTED_MODULE_5__amcharts_amcharts4_geodata_worldLow__["a" /* default */];
      chart2.projection = new __WEBPACK_IMPORTED_MODULE_3__amcharts_amcharts4_maps__["c" /* projections */].Miller();

      // polygons
      var polygonSeries = chart2.series.push(new __WEBPACK_IMPORTED_MODULE_3__amcharts_amcharts4_maps__["b" /* MapPolygonSeries */]());
      polygonSeries.useGeodata = true;
      // polygonSeries.mapPolygons.template.events.on('hit', ev => {
      //   chart2.zoomToMapObject(ev.target)
      //   console.log('click map', ev.target, ev)
      // })

      // template
      // let polygonTemplate = polygonSeries.mapPolygons.template
      // polygonTemplate.tooltipText = '{name}'
      // polygonTemplate.data = this.$store.getters.countriesAmcharts

      // polygonTemplate.fill = am4core.color('#5e72e4')
      // let hs = polygonTemplate.states.create('hover')
      // hs.properties.fill = am4core.color('#172b4d')
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer'
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Menu',
  created: function created() {
    this.$store.dispatch('fetchUser');
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch('userLogout');
    }
  }
});

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Coins',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbCoins: 0,
      search: '',
      currentSort: 'coin',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    filteredCoins: function filteredCoins() {
      var _this = this;

      this.nbCoins = 0;
      if (this.coins) {
        var filtered = this.coins.filter(function (coin) {
          return coin.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbCoins = filtered.length > 0 ? filtered.map(function (coin) {
          return coin.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    coins: function coins() {
      return this.$store.getters.coins;
    },
    continents: function continents() {
      return this.$store.getters.continents;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchCoins');
    this.$store.dispatch('fetchContinents');
  },

  methods: {
    goToCoinsContinent: function goToCoinsContinent(codeContinent) {
      this.$router.replace({ name: 'coin.continent', params: { code: codeContinent } });
    },
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.coins.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CoinsCountry',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbCoins: 0,
      search: '',
      currentSort: 'coin',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    title: function title() {
      return this.$store.getters.country;
    },
    filteredCoins: function filteredCoins() {
      var _this = this;

      this.nbCoins = 0;
      if (this.coins) {
        var filtered = this.coins.filter(function (coin) {
          return coin.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbCoins = filtered.length > 0 ? filtered.map(function (coin) {
          return coin.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    coins: function coins() {
      return this.$store.getters.coins;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchCountry', { code: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchCoins', { countryCode: this.$route.params.code.toUpperCase() });
  },

  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.coins.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CoinsContinent',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbCoins: 0,
      search: '',
      currentSort: 'coin',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    title: function title() {
      return this.$store.getters.continent;
    },
    filteredCoins: function filteredCoins() {
      var _this = this;

      this.nbCoins = 0;
      if (this.coins) {
        var filtered = this.coins.filter(function (coin) {
          return coin.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbCoins = filtered.length > 0 ? filtered.map(function (coin) {
          return coin.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    coins: function coins() {
      return this.$store.getters.coins;
    },
    countries: function countries() {
      return this.$store.getters.countries;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchContinent', { code: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchCountries', { codeContinent: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchCoins', { continentCode: this.$route.params.code.toUpperCase() });
  },

  methods: {
    goToCoinsCountry: function goToCoinsCountry(codeCountry) {
      this.$router.replace({ name: 'coin.country', params: { code: codeCountry } });
    },
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.coins.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CoinShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    coin: function coin() {
      return this.$store.getters.coin;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchCoin', { key: this.$route.params.key });
  },

  methods: {
    goBack: function goBack() {
      if (localStorage.back && localStorage.params) {
        var back = localStorage.back;
        var params = JSON.parse(localStorage.params);
        if (localStorage.back !== 'null') {
          if (localStorage.params) {
            this.$router.replace({ name: back });
          } else {
            this.$router.replace({ name: back, params: params });
          }
        }
      }
    },
    deleteCoin: function deleteCoin() {
      var key = this.$route.params.key;
      if (this.user) {
        this.$store.dispatch('deleteCoin', { key: key }).then(function () {
          window.location.href = '/coins';
        });
      }
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CoinShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      coinEdit: {}
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    coin: function coin() {
      var coin = this.$store.getters.coin;
      this.coinEdit = coin;
      return coin;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchCoin', { key: this.$route.params.key });
  },

  methods: {
    selectBook: function selectBook(book) {
      this.coinEdit.book = book;
    },
    addImage: function addImage() {
      this.coinEdit.images.push({ src: '' });
    },
    removeImage: function removeImage(index) {
      this.coinEdit.images.splice(index, 1);
    },
    updateCoin: function updateCoin() {
      var key = this.$route.params.key;
      if (this.user) {
        this.coinEdit.book = this.coinEdit.book.id;
        this.coinEdit.image = this.coinEdit.images[0].src;
        this.coinEdit.quantity = parseInt(this.coinEdit.quantity);
        this.coinEdit.year = this.coinEdit.year ? parseInt(this.coinEdit.year) : null;
        this.coinEdit.updated_at = new Date().toISOString();
        this.$store.dispatch('updateCoin', { data: this.coinEdit, key: key }).then(function () {
          window.location.href = '/coins/show/' + key;
        });
      }
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CoinNew',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      coin: {
        title: '',
        quantity: 0,
        year: '',
        book: null,
        continent: null,
        country: null,
        images: []
      },
      countries: null
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    continents: function continents() {
      return this.$store.getters.continents;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchContinents', { withCountries: true });
  },

  methods: {
    selectBook: function selectBook(book) {
      this.coin.book = book;
    },
    selectContinent: function selectContinent(continent) {
      this.coin.continent = continent.code;
      this.countries = continent.countries;
    },
    selectCountry: function selectCountry(country) {
      this.coin.country = country;
    },
    addImage: function addImage() {
      this.coin.images.push({ src: '' });
    },
    removeImage: function removeImage(index) {
      this.coin.images.splice(index, 1);
    },
    addCoin: function addCoin() {
      if (this.user) {
        this.coin.image = this.coin.images[0].src;
        this.coin.book = this.coin.book.id;
        this.coin.quantity = parseInt(this.coin.quantity);
        this.coin.year = this.coin.year ? parseInt(this.coin.year) : null;
        this.coin.uid = this.user.uid;
        this.coin.created_at = new Date().toISOString();
        this.coin.updated_at = new Date().toISOString();
        this.$store.dispatch('addCoin', { data: this.coin }).then(function () {
          window.location.href = '/coins';
        });
      }
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Banknotes',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbBanknotes: 0,
      search: '',
      currentSort: 'banknote',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    filteredBanknotes: function filteredBanknotes() {
      var _this = this;

      this.nbBanknotes = 0;
      if (this.banknotes) {
        var filtered = this.banknotes.filter(function (banknote) {
          return banknote.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbBanknotes = filtered.length > 0 ? filtered.map(function (banknote) {
          return banknote.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    banknotes: function banknotes() {
      return this.$store.getters.banknotes;
    },
    continents: function continents() {
      return this.$store.getters.continents;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBanknotes');
    this.$store.dispatch('fetchContinents');
  },

  methods: {
    goToBanknotesContinent: function goToBanknotesContinent(codeContinent) {
      this.$router.replace({ name: 'banknote.continent', params: { code: codeContinent } });
    },
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.banknotes.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BanknotesContinent',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbBanknotes: 0,
      search: '',
      currentSort: 'banknote',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    title: function title() {
      return this.$store.getters.continent;
    },
    filteredBanknotes: function filteredBanknotes() {
      var _this = this;

      this.nbBanknotes = 0;
      if (this.banknotes) {
        var filtered = this.banknotes.filter(function (banknote) {
          return banknote.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbBanknotes = filtered.length > 0 ? filtered.map(function (banknote) {
          return banknote.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    banknotes: function banknotes() {
      return this.$store.getters.banknotes;
    },
    countries: function countries() {
      return this.$store.getters.countries;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchContinent', { code: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchCountries', { codeContinent: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchBanknotes', { continentCode: this.$route.params.code.toUpperCase() });
  },

  methods: {
    goToBanknotesCountry: function goToBanknotesCountry(codeCountry) {
      this.$router.replace({ name: 'banknote.country', params: { code: codeCountry } });
    },
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.banknotes.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BanknotesCountry',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      nbBanknotes: 0,
      search: '',
      currentSort: 'banknote',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    title: function title() {
      return this.$store.getters.country;
    },
    filteredBanknotes: function filteredBanknotes() {
      var _this = this;

      this.nbBanknotes = 0;
      if (this.banknotes) {
        var filtered = this.banknotes.filter(function (banknote) {
          return banknote.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbBanknotes = filtered.length > 0 ? filtered.map(function (banknote) {
          return banknote.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }) : 0;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    banknotes: function banknotes() {
      return this.$store.getters.banknotes;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchCountry', { code: this.$route.params.code.toUpperCase() });
    this.$store.dispatch('fetchBanknotes', { countryCode: this.$route.params.code.toUpperCase() });
  },

  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.banknotes.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BanknoteShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    banknote: function banknote() {
      return this.$store.getters.banknote;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchBanknote', { key: this.$route.params.key });
  },

  methods: {
    deleteBanknote: function deleteBanknote() {
      var key = this.$route.params.key;
      if (this.user) {
        this.$store.dispatch('deleteBanknote', { key: key }).then(function () {
          window.location.href = '/banknotes';
        });
      }
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BanknoteShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      banknoteEdit: {}
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    banknote: function banknote() {
      var banknote = this.$store.getters.banknote;
      this.banknoteEdit = banknote;
      return banknote;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchBanknote', { key: this.$route.params.key });
  },

  methods: {
    selectBook: function selectBook(book) {
      this.banknoteEdit.book = book;
    },
    addImage: function addImage() {
      this.banknoteEdit.images.push({ src: '' });
    },
    removeImage: function removeImage(index) {
      this.banknoteEdit.images.splice(index, 1);
    },
    updateBanknote: function updateBanknote() {
      var key = this.$route.params.key;
      if (this.user) {
        this.banknoteEdit.book = this.banknoteEdit.book.id;
        this.banknoteEdit.image = this.banknoteEdit.images[0].src;
        this.banknoteEdit.quantity = parseInt(this.banknoteEdit.quantity);
        this.banknoteEdit.year = this.banknoteEdit.year ? parseInt(this.banknoteEdit.year) : null;
        this.banknoteEdit.updated_at = new Date().toISOString();
        this.$store.dispatch('updateBanknote', { data: this.banknoteEdit, key: key }).then(function () {
          window.location.href = '/banknotes/show/' + key;
        });
      }
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BanknoteNew',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      banknote: {
        title: '',
        quantity: 0,
        year: '',
        book: null,
        continent: null,
        country: null,
        images: []
      },
      countries: null
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    books: function books() {
      return this.$store.getters.books;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    continents: function continents() {
      return this.$store.getters.continents;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchContinents', { withCountries: true });
  },

  methods: {
    selectBook: function selectBook(book) {
      this.banknote.book = book;
    },
    selectContinent: function selectContinent(continent) {
      this.banknote.continent = continent.code;
      this.countries = continent.countries;
    },
    selectCountry: function selectCountry(country) {
      this.banknote.country = country;
    },
    addImage: function addImage() {
      this.banknote.images.push({ src: '' });
    },
    removeImage: function removeImage(index) {
      this.banknote.images.splice(index, 1);
    },
    addBanknote: function addBanknote() {
      if (this.user) {
        this.banknote.image = this.banknote.images[0].src;
        this.banknote.book = this.banknote.book.id;
        this.banknote.quantity = parseInt(this.banknote.quantity);
        this.banknote.year = this.banknote.year ? parseInt(this.banknote.year) : null;
        this.banknote.uid = this.user.uid;
        this.banknote.created_at = new Date().toISOString();
        this.banknote.updated_at = new Date().toISOString();
        this.$store.dispatch('addBanknote', { data: this.banknote }).then(function () {
          window.location.href = '/banknotes';
        });
      }
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Books',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      bookNew: '',
      nbBooks: 0,
      search: '',
      currentSort: 'book',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    filteredBooks: function filteredBooks() {
      var _this = this;

      if (this.books) {
        var filtered = this.books.filter(function (book) {
          return book.name.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
        });
        this.nbBooks = filtered.length;
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDir === 'desc') modifier = -1;
          if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
          if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPage - 1) * _this.pageSize;
          var end = _this.currentPage * _this.pageSize;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    books: function books() {
      return this.$store.getters.books;
    },
    maxBook: function maxBook() {
      return this.$store.getters.maxBook;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchMaxBook');
  },

  methods: {
    addBook: function addBook() {
      var data = {
        id: parseInt(this.maxBook.id) + 1,
        name: this.bookNew,
        uid: this.user.uid,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      this.$store.dispatch('addBook', { data: data }).then(function () {
        window.location.href = '/books';
      });
    },
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.pageSize < this.books.length) this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BookShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__layouts_Modal__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"], Menu: __WEBPACK_IMPORTED_MODULE_2__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      bookEdit: '',
      searchCoin: '',
      currentSortCoin: 'coin',
      currentSortDirCoin: 'asc',
      pageSizeCoin: 4,
      currentPageCoin: 1,
      searchBanknote: '',
      currentSortBanknote: 'banknote',
      currentSortDirBanknote: 'asc',
      pageSizeBanknote: 4,
      currentPageBanknote: 1
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    user: function user() {
      return this.$store.getters.user;
    },
    book: function book() {
      var book = this.$store.getters.book;
      this.bookEdit = book ? book.name : '';
      return book;
    },
    filteredCoins: function filteredCoins() {
      var _this = this;

      if (this.book && this.book.coins) {
        var filtered = this.book.coins.filter(function (coin) {
          return coin.title.toLowerCase().indexOf(_this.searchCoin.toLowerCase()) > -1;
        });
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this.currentSortDirCoin === 'desc') modifier = -1;
          if (a[_this.currentSortCoin] < b[_this.currentSortCoin]) return -1 * modifier;
          if (a[_this.currentSortCoin] > b[_this.currentSortCoin]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this.currentPageCoin - 1) * _this.pageSizeCoin;
          var end = _this.currentPageCoin * _this.pageSizeCoin;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    },
    filteredBanknotes: function filteredBanknotes() {
      var _this2 = this;

      if (this.book && this.book.banknotes) {
        var filtered = this.book.banknotes.filter(function (banknote) {
          return banknote.title.toLowerCase().indexOf(_this2.searchBanknote.toLowerCase()) > -1;
        });
        return filtered.sort(function (a, b) {
          var modifier = 1;
          if (_this2.currentSortDirBanknote === 'desc') modifier = -1;
          if (a[_this2.currentSortBanknote] < b[_this2.currentSortBanknote]) return -1 * modifier;
          if (a[_this2.currentSortBanknote] > b[_this2.currentSortBanknote]) return 1 * modifier;
          return 0;
        }).filter(function (row, index) {
          var start = (_this2.currentPageBanknote - 1) * _this2.pageSizeBanknote;
          var end = _this2.currentPageBanknote * _this2.pageSizeBanknote;
          if (index >= start && index < end) return true;
        }).sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return null;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBook', { key: this.$route.params.key });
  },

  methods: {
    updateBook: function updateBook() {
      var name = this.bookEdit;
      var key = this.$route.params.key;
      if (this.user) {
        this.$store.dispatch('updateBook', { name: name, key: key }).then(function () {
          window.location.href = '/books/show/' + key;
        });
      }
    },
    deleteBook: function deleteBook() {
      var key = this.$route.params.key;
      if (this.user && this.book) {
        var bookId = this.book.id;
        this.$store.dispatch('deleteBook', { key: key, bookId: bookId });
      }
    },
    nextPageCoin: function nextPageCoin() {
      if (this.currentPageCoin * this.pageSizeCoin < this.book.coins.length) this.currentPageCoin++;
    },
    prevPageCoin: function prevPageCoin() {
      if (this.currentPageCoin > 1) this.currentPageCoin--;
    },
    nextPageBanknote: function nextPageBanknote() {
      if (this.currentPageBanknote * this.pageSizeBanknote < this.book.banknotes.length) this.currentPageBanknote++;
    },
    prevPageBanknote: function prevPageBanknote() {
      if (this.currentPageBanknote > 1) this.currentPageBanknote--;
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Menu__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BookShow',
  components: { Footer: __WEBPACK_IMPORTED_MODULE_0__layouts_Footer__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__layouts_Menu__["a" /* default */] },
  data: function data() {
    return {
      editUser: {
        displayName: '',
        photoURL: '',
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        choose: 'username'
      },
      error: null,
      loading: false
    };
  },

  computed: {
    layout: function layout() {
      return 'Layout';
    },
    user: function user() {
      var user = this.$store.getters.user;
      if (user) {
        this.editUser.displayName = user.displayName;
        this.editUser.photoURL = user.photoURL;
        this.editUser.email = user.email;
      }
      return user;
    },
    booksCount: function booksCount() {
      return this.$store.getters.books ? this.$store.getters.books.length : 0;
    },
    coinsCount: function coinsCount() {
      return this.$store.getters.coinsCount;
    },
    banknotesCount: function banknotesCount() {
      return this.$store.getters.banknotesCount;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchCoinsCount');
    this.$store.dispatch('fetchBanknotesCount');
  },

  methods: {
    selectPhotoURL: function selectPhotoURL(photoURL) {
      this.editUser.photoURL = photoURL;
    },
    updateUser: function updateUser() {
      this.editUser.updated_at = new Date().toISOString();
      console.log('updateUser', this.editUser, this.user);
    }
  }
});

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Default',
  components: { Nav: __WEBPACK_IMPORTED_MODULE_0__Nav__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('fetchUser');
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Nav',
  methods: {
    subIsActive: function subIsActive(input) {
      var _this = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this.$route.path.indexOf(path) === 0;
      });
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAAAnCAMAAABt9LknAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAZlBMVEUAAABfcuVfc+Nfb+RcceJecuVdcuRecuReb99dcORdceNdcuNdceNccuRccuJeft9ecuRdcuRdceReceVdceNcceJdceRdcONecuNecuRfdN9fceNfb+ddcuReceRec+RecuT///+l5nKZAAAAIHRSTlMAJz8vR6bGvg9n1s5/X08Hju72nm9X5neWthc3H96uhjKvwAsAAAABYktHRCHEbA0WAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAEcklEQVRYw+2Y65arKBBGjZdgFMULoqIo7/+Uw12Npk3SmZWZs0796ECJsC2Lr7A978+zi+8H32Z4z8LoyqWBy7dJXrb4lvAUZr4X50mCvk3zIntRVrUNOeTY85pvIz1vISnb2PU6TmLUd9+GetLimvd06dIqqgoPJcO/spgP/Y/ON7IyW/cnPrVV7OF18IUUCXPdQXTiZ+ffGBaqAD8Kn9J1v+aYYe57Ptg4pWHbZaLzXgilqqUfhd9EsebXLid88JppR0+sFr1PLyeKPgaPkmQNH0ecUBKwRIhOu6N37/x9+gvg0+c21MzXpTUkvINFw/i9Xhr6iv6W/qOGytXepDUnPotF1u/U0tDz4ov0aHeECRaIIRLbMg3aeeb17k5Jn0r8YEsfAQB0hgWiBeRVKn5zL+5KLnbQKBaFgPNyMqWwEFd1CChM5IRpFxi/CJmo95xNuehnvbgfOC28dEAOLqPNIWbkN/UbZ4Jt7nM/RaTawyv6phJ/pi29bOjhPje+UY6KU/2u2Ih6k3Q6GSWEErOh4tZa7a9QYRyZKPfaDErvxi66Jy3l1xlGci3Y44ChCfDZO6b31eTDM/QVs4uRxLXQmj4mC9Bo/G4ov7qW3uF4GVyt88fnhLDk2nc4CgjqJnJcYhU9raxYn9HLqIPUYoOrieiKPpeeHsKa6VehEoOXAFhKAEo1RKc84QnEOF08xiYypJSNbEyDImJ8Pj5eqswRAiUsf4peOiPV6sWMrWzMa3qVGkqrw8HRy8oT6icWEQ5ksBK9fqgjLsNAtvu2nZqiwAVOyXLMPKLPZAhEUJHMtxP6Sgbh4vIClbZIWXq8UjBH3+hcttktn77aYLTumRdPQrpKPBVp3YkBd4f0ek2s1/qRXvtk8K6eRXIZIhs6xOyGVvTqkbU4K0L1fhYGcdaabTi0ybszABiJ8Go35EaJdvRI0pL4nF4XZeaOBeCe3soIwcgNYG4pzbyi9yOnAyv6uT/I87wq7l2GXm+24pweO/ruAX1sdYVdrD91S7EtPVo0aEPvFUl7VzRRuy+1jl6lQEWjM/rM0cMH9CINjWiq79DFf0A/aRWa4XRH713gtKnAmJS3HfxCr/K1rtf0WsKyl+k9hJkrQD/RU/WM1C4yeg/Mh4x39OCCo9dxcJrjdqP4nHyZ3gJGJ/S5FWqtGg/oRa1LID28tNAHNv30OYebg6eunS/Tq80LTuhVxAM7+hH98Phrb6E3NcjQKwkThzM/5a/R1yCTi6kK0p3Qh7Y2QP4DvTM0F4/pabWiH/jGXqCXL80cIRrvibwXBw7Cn6EfkvLo68QeV4sVvZEDYRN4md7euc2oA80p7NC6P6FH2bT5/8ienpYremowapWdz9NDB1/Hp/SxKW2d1/yoOSDhVX3w1ZRDCJ2whlCanWSAU30L5NeG9sXQjcWipSfLRCvbNOgNTqCH9nTi/GopXex8OZO+3MygkIsg4Xm4OUfY/gc+V//a/9NQmP1+km/YpQdSgotvc7xNH8GG/n6iv/Yn2z+rfL+80qvRTgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0xMS0xM1QxODo0NjozMiswMDowMLwKmnQAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMTEtMTNUMTg6NDc6MTErMDA6MDBRWFQWAAAAAElFTkSuQmCC"

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_firebase_env__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layouts_Default__ = __webpack_require__(417);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Layout', __WEBPACK_IMPORTED_MODULE_7__layouts_Default__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_6__config_firebase_env__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__lang__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]
});

/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a94049e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(225);
function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a94049e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */,
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath,on:{"authenticated":_vm.setAuthenticated}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Register__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Coin_Coins__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Coin_CoinsCountry__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Coin_CoinsContinent__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Coin_CoinShow__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Coin_CoinEdit__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Coin_CoinNew__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Banknote_Banknotes__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Banknote_BanknotesContinent__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Banknote_BanknotesCountry__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Banknote_BanknoteShow__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Banknote_BanknoteEdit__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Banknote_BanknoteNew__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book_Books__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book_BookShow__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_User_Profile__ = __webpack_require__(344);




























__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: { name: 'login' }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */]
  }, {
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Register__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/coins',
    name: 'coin',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Coin_Coins__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/coins/continent/:code',
    name: 'coin.continent',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Coin_CoinsContinent__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/coins/country/:code',
    name: 'coin.country',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Coin_CoinsCountry__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/coins/show/:key',
    name: 'coin.show',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Coin_CoinShow__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/coins/edit/:key',
    name: 'coin.edit',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Coin_CoinEdit__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/coins/new',
    name: 'coin.new',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Coin_CoinNew__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes',
    name: 'banknote',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Banknote_Banknotes__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes/continent/:code',
    name: 'banknote.continent',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Banknote_BanknotesContinent__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes/country/:code',
    name: 'banknote.country',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Banknote_BanknotesCountry__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes/show/:key',
    name: 'banknote.show',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Banknote_BanknoteShow__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes/edit/:key',
    name: 'banknote.edit',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Banknote_BanknoteEdit__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/banknotes/new',
    name: 'banknote.new',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Banknote_BanknoteNew__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/books',
    name: 'book',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Book_Books__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/books/show/:key',
    name: 'book.show',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Book_BookShow__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }, {
    path: '/user/profile/:uid',
    name: 'user.profile',
    component: __WEBPACK_IMPORTED_MODULE_21__components_User_Profile__["a" /* default */],
    meta: { requiresAuth: true },
    fallback: false
  }]
});

router.beforeEach(function (to, from, next) {
  localStorage.removeItem('back');
  localStorage.removeItem('params');
  localStorage.back = from.name;
  localStorage.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(from.params).length > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(from.params) : '{}';
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f24873c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(240);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f24873c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"main-container",staticStyle:{"background":"var(--default)"}},[_c('div',{staticClass:"header bg-gradient-primary py-7 py-lg-8"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-body text-center mb-7"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-5 col-md-6"},[_c('h1',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.$i18n.t('login.title')))]),_vm._v(" "),_c('p',{staticClass:"text-lead text-light"},[_vm._v(_vm._s(_vm.$i18n.t('login.subtitle')))])])])])]),_vm._v(" "),_c('div',{staticClass:"separator separator-bottom separator-skew zindex-100"},[_c('svg',{attrs:{"x":"0","y":"0","viewBox":"0 0 2560 100","preserveAspectRatio":"none","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('polygon',{staticClass:"fill-default",attrs:{"points":"2560 0 2560 100 0 100"}})])])]),_vm._v(" "),_c('div',{staticClass:"container mt--8 pb-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-5 col-md-7"},[_c('div',{staticClass:"card bg-secondary shadow border-0"},[_c('div',{staticClass:"card-body px-lg-5 py-lg-5"},[_c('div',{staticClass:"text-center text-muted mb-4"},[_c('small',[_vm._v(_vm._s(_vm.$i18n.t('login.credentials.title')))])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('span',{staticClass:"alert-inner--text"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "+_vm._s(_vm.error))])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"form-group mb-3"},[_c('div',{staticClass:"input-group input-group-alternative"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"placeholder":_vm.$i18n.t('login.email'),"type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":_vm.$i18n.t('login.password'),"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary my-4",attrs:{"type":"submit","disable":_vm.loading}},[(_vm.loading)?_c('span',[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"10"}})]):_c('span',[_vm._v(_vm._s(_vm.$i18n.t('login.credentials.signin')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 text-center"},[_c('a',{staticClass:"text-light",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.replace({ name: 'register' })}}},[_c('small',[_vm._v(_vm._s(_vm.$i18n.t('login.new_account')))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"ni ni-email-83"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"ni ni-lock-circle-open"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b1df70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(243);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8b1df70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b1df70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"main-container",staticStyle:{"background":"var(--default)"}},[_c('div',{staticClass:"header bg-gradient-primary py-7 py-lg-8"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-body text-center mb-7"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-5 col-md-6"},[_c('h1',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.$i18n.t('login.title')))]),_vm._v(" "),_c('p',{staticClass:"text-lead text-light"},[_vm._v(_vm._s(_vm.$i18n.t('login.subtitle')))])])])])]),_vm._v(" "),_c('div',{staticClass:"separator separator-bottom separator-skew zindex-100"},[_c('svg',{attrs:{"x":"0","y":"0","viewBox":"0 0 2560 100","preserveAspectRatio":"none","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('polygon',{staticClass:"fill-default",attrs:{"points":"2560 0 2560 100 0 100"}})])])]),_vm._v(" "),_c('div',{staticClass:"container mt--8 pb-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-6 col-md-8"},[_c('div',{staticClass:"card bg-secondary shadow border-0"},[_c('div',{staticClass:"card-body px-lg-5 py-lg-5"},[_c('div',{staticClass:"text-center text-muted mb-4"},[_c('small',[_vm._v(_vm._s(_vm.$i18n.t('register.text')))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayName),expression:"displayName"}],staticClass:"form-control",attrs:{"placeholder":_vm.$i18n.t('register.displayName'),"type":"text"},domProps:{"value":(_vm.displayName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative mb-3"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"placeholder":_vm.$i18n.t('register.email'),"type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":_vm.$i18n.t('register.password'),"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.photoURL)?_c('span',[_c('i',{staticClass:"far fa-thumbs-up"})]):_c('span',[_vm._v("\n                          "+_vm._s(_vm.$i18n.t('register.choose_image'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary mt-4",on:{"click":function($event){$event.preventDefault();_vm.register()}}},[_vm._v(_vm._s(_vm.$i18n.t('register.create_account')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"text-light",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.replace({ name: 'login' })}}},[_c('small',[_vm._v(_vm._s(_vm.$i18n.t('register.back')))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"ni ni-hat-3"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"ni ni-email-83"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"ni ni-lock-circle-open"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45023a65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45023a65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45023a65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"row align-items-center justify-content-xl-between"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"copyright text-center text-xl-left text-muted"},[_vm._v("\n        © 2019 "),_c('span',{staticClass:"font-weight-bold ml-1 color-primary"},[_vm._v("Numisma")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:" dropdown-header noti-title"},[_c('h6',{staticClass:"text-overflow m-0"},[_vm._v(_vm._s(_vm.$i18n.t('dashboard.welcome')))])]),_vm._v(" "),(_vm.user && _vm.user.uid)?_c('router-link',{attrs:{"to":{ name: 'user.profile', params: { uid: _vm.user.uid } },"replace":""}},[_c('div',{staticClass:"dropdown-item"},[_c('i',{staticClass:"ni ni-single-02"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$i18n.t('user.profile')))])])]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":"/login","replace":""},nativeOn:{"click":function($event){return _vm.logout($event)}}},[_c('div',{staticClass:"dropdown-item"},[_c('i',{staticClass:"ni ni-user-run"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$i18n.t('global.logout')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-home"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.dashboard'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Dashboard"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-8"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4"},[_c('div',{staticClass:"card card-stats mb-4 mb-xl-0"},[_c('div',{staticClass:"card-body btn-hover",on:{"click":function($event){_vm.$router.replace({ name: 'coin' })}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"card-title text-uppercase text-muted mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('global.coins')))]),_vm._v(" "),_c('span',{staticClass:"h2 font-weight-bold mb-0"},[(_vm.coinsCount !== null)?_c('span',[_vm._v(_vm._s(_vm.coinsCount))]):_c('span',[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"25"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"icon icon-shape bg-danger text-white rounded-circle shadow"},[_c('i',{staticClass:"fas fa-coins"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4"},[_c('div',{staticClass:"card card-stats mb-4 mb-xl-0"},[_c('div',{staticClass:"card-body btn-hover",on:{"click":function($event){_vm.$router.replace({ name: 'banknote' })}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"card-title text-uppercase text-muted mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('global.banknotes')))]),_vm._v(" "),_c('span',{staticClass:"h2 font-weight-bold mb-0"},[(_vm.banknotesCount !== null)?_c('span',[_vm._v(_vm._s(_vm.banknotesCount))]):_c('span',[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"25"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"icon icon-shape bg-warning text-white rounded-circle shadow"},[_c('i',{staticClass:"far fa-money-bill-alt"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4"},[_c('div',{staticClass:"card card-stats mb-4 mb-xl-0"},[_c('div',{staticClass:"card-body btn-hover",on:{"click":function($event){_vm.$router.replace({ name: 'book' })}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"card-title text-uppercase text-muted mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('global.books')))]),_vm._v(" "),_c('span',{staticClass:"h2 font-weight-bold mb-0"},[_c('span',[_vm._v(_vm._s(_vm.books ? _vm.books.length : 0))])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"icon icon-shape bg-yellow text-white rounded-circle shadow"},[_c('i',{staticClass:"fas fa-book"})])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[(_vm.coinsBanknotesByContinent)?_c('div',{attrs:{"id":"listMap"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('tbody',_vm._l((_vm.coinsBanknotesByContinent),function(continent,index){return _c('tr',{key:index},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.$i18n.t('continents.'+continent.id)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn full-width",staticStyle:{"color":"white"},style:({'background-color': continent.color}),attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToCoinsContinent(continent.id)}}},[_vm._v("\n                        "+_vm._s(continent.nbCoins)+" "),_c('i',{staticClass:"fas fa-coins"})])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn full-width",staticStyle:{"color":"white"},style:({'background-color': continent.color}),attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToBanknotesContinent(continent.id)}}},[_vm._v("\n                        "+_vm._s(continent.nbBanknotes)+" "),_c('i',{staticClass:"far fa-money-bill-alt"})])])])}))])])]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a8fad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coins_vue__ = __webpack_require__(307);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22a8fad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a8fad0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal-mask",staticStyle:{"display":"block"},attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),_c('span',{attrs:{"id":"header-title-coin"}},[_vm._v(_vm._s(_vm.$i18n.t('coins.list')))]),_vm._v(" "),(_vm.coins)?_c('small',[_vm._v(_vm._s(_vm.nbCoins > 1 ? _vm.nbCoins + ' ' + _vm.$i18n.t('global.coins').toLowerCase() : _vm.nbCoins + ' ' + _vm.$i18n.t('global.coin').toLowerCase()))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","display":"flex"}},[_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-sm btn-secondary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$i18n.t('coins.select_continent')))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.continents),function(continent,index){return _c('a',{key:'continent'+index,staticClass:"dropdown-item full-width",on:{"click":function($event){_vm.goToCoinsContinent(continent.code.toLowerCase())}}},[_vm._v(_vm._s(_vm.$i18n.t('continents.'+continent.code)))])}))])])]),_vm._v(" "),(_vm.coins)?_c('div',{attrs:{"id":"listCoins"}},[(_vm.coins.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.coin'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCoins),function(coin,index){return _c('tr',{key:coin.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticClass:"div-img-coin"},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('img',{staticClass:"img-responsive img-coin",attrs:{"src":coin.image,"alt":coin.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(coin.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(coin.book.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),(coin.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+coin.country.toLowerCase()+'/flat/24.png',"alt":coin.country}}),_vm._v("\n                          "+_vm._s(_vm.$i18n.t('countries.' + coin.country))+",\n                        ")]):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.$i18n.t('continents.' + coin.continent))+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(coin.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.coins.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.coins.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinsCountry_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757439f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinsCountry_vue__ = __webpack_require__(309);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinsCountry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757439f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinsCountry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0"},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.$i18n.t('countries.'+_vm.title.code)))]):_vm._e(),_vm._v(" "),(_vm.coins)?_c('small',[_vm._v(_vm._s(_vm.nbCoins > 1 ? _vm.nbCoins + ' ' + _vm.$i18n.t('global.coins').toLowerCase() : _vm.nbCoins + ' ' + _vm.$i18n.t('global.coin').toLowerCase()))]):_vm._e()])]),_vm._v(" "),(_vm.coins)?_c('div',{attrs:{"id":"listCoins"}},[(_vm.coins.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                      "+_vm._s(_vm.$i18n.t('global.coin'))+"\n                      "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                      "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                      "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCoins),function(coin,index){return _c('tr',{key:coin.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('img',{staticClass:"img-responsive img-coin",attrs:{"src":coin.image,"alt":coin.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(coin.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(coin.book.name))])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(coin.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.coins.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.coins.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinsContinent_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d565efc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinsContinent_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d565efc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinsContinent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d565efc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinsContinent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.$i18n.t('continents.'+_vm.title.code)))]):_vm._e(),_vm._v(" "),(_vm.coins)?_c('small',[_vm._v(_vm._s(_vm.nbCoins > 1 ? _vm.nbCoins + ' ' + _vm.$i18n.t('global.coins').toLowerCase() : _vm.nbCoins + ' ' + _vm.$i18n.t('global.coin').toLowerCase()))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","display":"flex"}},[(_vm.countries)?_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-sm btn-secondary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$i18n.t('coins.select_country')))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",staticStyle:{"height":"350px","overflow-y":"scroll"},attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.countries),function(country,index){return _c('a',{key:'country'+index,staticClass:"dropdown-item full-width",on:{"click":function($event){_vm.goToCoinsCountry(country.code.toLowerCase())}}},[_vm._v(_vm._s(_vm.$i18n.t('countries.'+country.code)))])}))]):_vm._e()])]),_vm._v(" "),(_vm.coins)?_c('div',{attrs:{"id":"listCoins"}},[(_vm.coins.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.coin'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCoins),function(coin,index){return _c('tr',{key:coin.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('img',{staticClass:"img-responsive img-coin",attrs:{"src":coin.image,"alt":coin.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(coin.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(coin.book.name))])]),_c('br'),_vm._v(" "),(coin.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+coin.country.toLowerCase()+'/flat/24.png',"alt":coin.country}}),_vm._v("\n                          "+_vm._s(_vm.$i18n.t('countries.' + coin.country))+",\n                        ")]):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.$i18n.t('continents.' + coin.continent))+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(coin.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.coins.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.coins.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinShow_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e231308_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinShow_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e231308"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e231308_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-7 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-lg-12 order-xl-2 mb-5 mb-xl-0"},[(_vm.coin)?_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"row justify-content-center",staticStyle:{"height":"0"}},[_c('div',{staticClass:"col-lg-3 order-lg-2"},[_c('button',{attrs:{"type":"button","data-toggle":"modal","data-target":"#coin","id":"coin-image"}},[_c('div',{staticClass:"card-profile-image"},[_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.coin.image,"alt":_vm.coin.title}})])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"coin","tabindex":"-1","role":"dialog","aria-labelledby":_vm.coin.title,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.coin.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.coin.images && _vm.coin.images.length > 1)?_c('div',[_c('carousel',{staticClass:"full-width",attrs:{"per-page":1}},_vm._l((_vm.coin.images),function(image,index){return _c('slide',{key:'image' + index + _vm.coin.key},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.src,"alt":_vm.coin.title}})])}))],1):_c('div',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.coin.image,"alt":_vm.coin.title}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.close')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn btn-sm btn-info mr-4",on:{"click":function($event){_vm.$router.replace({ name: 'coin' })}}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.back'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"float-right hidden-xs"},[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.$router.replace({ name: 'coin.edit', params: { key: _vm.$route.params.key } })}}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.edit'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","data-toggle":"modal","data-target":"#delete"}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"delete","tabindex":"-1","role":"dialog","aria-labelledby":_vm.coin.title,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$i18n.t('global.delete')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$i18n.t('coins.delete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.no')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.deleteCoin()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.yes')))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card-profile-stats d-flex justify-content-center mt-md-5"},[_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.coin.quantity))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))])]),_vm._v(" "),(_vm.coin.year !== undefined)?_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.coin.year))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h3',[_c('i',[_vm._v(_vm._s(_vm.coin.title))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.coin.book.name))]),_vm._v(" "),_c('div',{staticClass:"h5 font-weight-300 mb-3",staticStyle:{"vertical-align":"middle"}},[(_vm.coin.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+_vm.coin.country.toLowerCase()+'/flat/24.png',"alt":_vm.coin.country}}),_vm._v("\n                  "+_vm._s(_vm.$i18n.t('countries.' + _vm.coin.country))+",\n                ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$i18n.t('continents.' + _vm.coin.continent))+"\n              ")]),_vm._v(" "),(_vm.coin.description)?_c('p',[_vm._v(_vm._s(_vm.coin.description))]):_vm._e()])])]):_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"card-body pt-10 pt-md-4"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinEdit_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fe670e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinEdit_vue__ = __webpack_require__(317);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fe670e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-7 pt-5 pt-md-6"}),_vm._v(" "),(_vm.coin)?_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-xl-4 order-xl-2 mb-5 mb-xl-0"},[_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-3 order-lg-2"},[_c('div',{staticClass:"card-profile-image"},[_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.coin.image,"alt":_vm.coin.title}})])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"text-center mt-8"},[_c('h3',[_c('i',[_vm._v(_vm._s(_vm.coinEdit.title))])]),_vm._v(" "),_c('div',{staticClass:"h5 font-weight-300"},[(_vm.coin.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+_vm.coin.country.toLowerCase()+'/flat/24.png',"alt":_vm.coin.country}}),_vm._v("\n                  "+_vm._s(_vm.$i18n.t('countries.' + _vm.coin.country))+",\n                ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$i18n.t('continents.' + _vm.coin.continent))+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-8 order-xl-1"},[_c('div',{staticClass:"card bg-secondary shadow"},[_c('div',{staticClass:"card-header bg-white border-0"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('coins.edit')))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.updateCoin()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: _vm.$route.params.key } })}}},[_vm._v(_vm._s(_vm.$i18n.t('global.cancel')))])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('coins.info')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.coin')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coinEdit.title),expression:"coinEdit.title"}],ref:"title",staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.coinEdit.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coinEdit, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.coinEdit.description),expression:"coinEdit.description"}],staticClass:"form-control form-control-alternative",attrs:{"rows":"4"},domProps:{"value":(_vm.coinEdit.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coinEdit, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"quantity"}},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coinEdit.quantity),expression:"coinEdit.quantity"}],ref:"quantity",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.coinEdit.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coinEdit, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"year"}},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coinEdit.year),expression:"coinEdit.year"}],ref:"year",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.coinEdit.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coinEdit, "year", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"book"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.coinEdit.book)?_c('span',[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.coinEdit.book.name)+"\n                          ")]):_c('span',[_vm._v("\n                            "+_vm._s(_vm.$i18n.t('coins.none'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.books),function(book,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectBook(book)}}},[_vm._v(_vm._s(book.name))])}))])])])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('global.images')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group focused"},[_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addImage()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.add'))+"\n                        ")])]),_vm._v(" "),_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("URL")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.coinEdit.images),function(image,index){return _c('tr',[_c('th',{key:index,attrs:{"scope":"row"}},[_c('div',{staticClass:"media align-items-center"},[_c('a',{staticClass:"avatar rounded-circle mr-3",attrs:{"href":"#"}},[_c('img',{attrs:{"src":image.src}})])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coinEdit.images[index].src),expression:"coinEdit.images[index].src"}],ref:"images[]",refInFor:true,staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.coinEdit.images[index].src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coinEdit.images[index], "src", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-sm btn-icon-only text-light",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeImage(index)}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete')))])])])])])}))])])])])])])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinNew_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab623664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinNew_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab623664"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoinNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab623664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoinNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Coin"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),(_vm.continents && _vm.books)?_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-xl-12 order-xl-1"},[_c('div',{staticClass:"card bg-secondary shadow"},[_c('div',{staticClass:"card-header bg-white border-0"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('coins.new')))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.addCoin()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.$router.replace({ name: 'coin' })}}},[_vm._v(_vm._s(_vm.$i18n.t('global.cancel')))])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('coins.info')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.coin')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coin.title),expression:"coin.title"}],ref:"title",staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.coin.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coin, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.coin.description),expression:"coin.description"}],staticClass:"form-control form-control-alternative",attrs:{"rows":"4"},domProps:{"value":(_vm.coin.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coin, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"continent"}},[_vm._v(_vm._s(_vm.$i18n.t('global.continent')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                          "+_vm._s(_vm.coin.continent ? _vm.$i18n.t('continents.'+_vm.coin.continent) : _vm.$i18n.t('coins.none'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.continents),function(continent,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectContinent(continent)}}},[_vm._v(_vm._s(_vm.$i18n.t('continents.'+continent.code)))])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"country"}},[_vm._v(_vm._s(_vm.$i18n.t('global.country')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"disabled":!_vm.countries || _vm.coin.continent === 'XX',"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                          "+_vm._s(_vm.coin.country ? _vm.$i18n.t('countries.'+_vm.coin.country) : _vm.$i18n.t('coins.none'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.countries),function(country,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectCountry(country)}}},[_vm._v(_vm._s(_vm.$i18n.t('countries.'+country)))])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"quantity"}},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coin.quantity),expression:"coin.quantity"}],ref:"quantity",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.coin.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coin, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"year"}},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coin.year),expression:"coin.year"}],ref:"year",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.coin.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coin, "year", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"book"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.coin.book)?_c('span',[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.coin.book.name)+"\n                          ")]):_c('span',[_vm._v("\n                            "+_vm._s(_vm.$i18n.t('coins.none'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.books),function(book,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectBook(book)}}},[_vm._v(_vm._s(book.name))])}))])])])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('global.images')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group focused"},[_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addImage()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.add'))+"\n                        ")])]),_vm._v(" "),_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("URL")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.coin.images),function(image,index){return _c('tr',[_c('th',{key:index,attrs:{"scope":"row"}},[_c('div',{staticClass:"media align-items-center"},[_c('a',{staticClass:"avatar rounded-circle mr-3",attrs:{"href":"#"}},[_c('img',{attrs:{"src":image.src}})])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coin.images[index].src),expression:"coin.images[index].src"}],ref:"images[]",refInFor:true,staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.coin.images[index].src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coin.images[index], "src", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-sm btn-icon-only text-light",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeImage(index)}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete')))])])])])])}))])])])])])])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banknotes_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def84ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banknotes_vue__ = __webpack_require__(323);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1def84ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banknotes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def84ab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banknotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknote"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),_c('span',{attrs:{"id":"header-title-banknote"}},[_vm._v(_vm._s(_vm.$i18n.t('banknotes.list')))]),_vm._v(" "),(_vm.banknotes)?_c('small',[_vm._v(_vm._s(_vm.nbBanknotes > 1 ? _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknotes').toLowerCase() : _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknote').toLowerCase()))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","display":"flex"}},[_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-sm btn-secondary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$i18n.t('coins.select_continent')))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.continents),function(continent,index){return _c('a',{key:'continent'+index,staticClass:"dropdown-item full-width",on:{"click":function($event){_vm.goToBanknotesContinent(continent.code.toLowerCase())}}},[_vm._v(_vm._s(_vm.$i18n.t('continents.'+continent.code)))])}))])])]),_vm._v(" "),(_vm.banknotes)?_c('div',{attrs:{"id":"listBanknotes"}},[(_vm.banknotes.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.banknote'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBanknotes),function(banknote,index){return _c('tr',{key:banknote.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticStyle:{"width":"100px"}},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('img',{staticClass:"img-responsive img-banknote",attrs:{"src":banknote.image,"alt":banknote.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(banknote.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(banknote.book.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),(banknote.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+banknote.country.toLowerCase()+'/flat/24.png',"alt":banknote.country}}),_vm._v(" "+_vm._s(_vm.$i18n.t('countries.' + banknote.country))+",\n                        ")]):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.$i18n.t('continents.' + banknote.continent))+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(banknote.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.banknotes.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.banknotes.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknotesContinent_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1f62de8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknotesContinent_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1f62de8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknotesContinent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1f62de8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknotesContinent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknotes"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.$i18n.t('continents.'+_vm.title.code)))]):_vm._e(),_vm._v(" "),(_vm.banknotes)?_c('small',[_vm._v(_vm._s(_vm.nbBanknotes > 1 ? _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknotes').toLowerCase() : _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknote').toLowerCase()))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","display":"flex"}},[(_vm.countries)?_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-sm btn-secondary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$i18n.t('coins.select_country')))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",staticStyle:{"height":"350px","overflow-y":"scroll"},attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.countries),function(country,index){return _c('a',{key:'country'+index,staticClass:"dropdown-item full-width",on:{"click":function($event){_vm.goToBanknotesCountry(country.code.toLowerCase())}}},[_vm._v(_vm._s(_vm.$i18n.t('countries.'+country.code)))])}))]):_vm._e()])]),_vm._v(" "),(_vm.banknotes)?_c('div',{attrs:{"id":"listBanknotes"}},[(_vm.banknotes.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.banknote'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBanknotes),function(banknote,index){return _c('tr',{key:banknote.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('img',{staticClass:"img-responsive img-banknote",attrs:{"src":banknote.image,"alt":banknote.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(banknote.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(banknote.book.name))])]),_c('br'),_vm._v(" "),(banknote.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+banknote.country.toLowerCase()+'/flat/24.png',"alt":banknote.country}}),_vm._v(" "+_vm._s(_vm.$i18n.t('countries.' + banknote.country))+",\n                        ")]):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.$i18n.t('continents.' + banknote.continent))+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(banknote.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.banknotes.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.banknotes.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknotesCountry_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cf790e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknotesCountry_vue__ = __webpack_require__(328);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknotesCountry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cf790e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknotesCountry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknotes"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.$i18n.t('countries.'+_vm.title.code)))]):_vm._e(),_vm._v(" "),(_vm.banknotes)?_c('small',[_vm._v(_vm._s(_vm.nbBanknotes > 1 ? _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknotes').toLowerCase() : _vm.nbBanknotes + ' ' + _vm.$i18n.t('global.banknote').toLowerCase()))]):_vm._e()])]),_vm._v(" "),(_vm.banknotes)?_c('div',{attrs:{"id":"listBanknotes"}},[(_vm.banknotes.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"20%"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"60%"},on:{"click":function($event){_vm.sort('title')}}},[_vm._v("\n                      "+_vm._s(_vm.$i18n.t('global.banknote'))+"\n                      "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col","width":"10%"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                      "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                      "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBanknotes),function(banknote,index){return _c('tr',{key:banknote.key},[_c('td',{attrs:{"scope":"row","width":"20%"}},[_c('div',{staticStyle:{"width":"100px","margin":"0 auto"}},[_c('a',{on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('img',{staticClass:"img-responsive img-banknote",attrs:{"src":banknote.image,"alt":banknote.title}})])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"60%"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(banknote.title))]),_c('br'),_vm._v(" "),_c('small',[_c('i',[_vm._v(_vm._s(banknote.book.name))])])]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_vm._v(_vm._s(banknote.quantity))]),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"10%"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.banknotes.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.banknotes.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteShow_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42bb3ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteShow_vue__ = __webpack_require__(331);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c42bb3ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42bb3ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknote"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-7 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-lg-12 order-xl-2 mb-5 mb-xl-0"},[(_vm.banknote)?_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"row justify-content-center",staticStyle:{"height":"0"}},[_c('div',{staticClass:"col-lg-3 order-lg-2"},[_c('button',{attrs:{"type":"button","data-toggle":"modal","data-target":"#banknote","id":"banknote-image"}},[_c('div',{staticClass:"card-profile-image"},[_c('img',{staticClass:"img-fluid rounded shadow",attrs:{"src":_vm.banknote.image,"alt":_vm.banknote.title}})])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"banknote","tabindex":"-1","role":"dialog","aria-labelledby":_vm.banknote.title,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.banknote.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.banknote.images && _vm.banknote.images.length > 1)?_c('div',[_c('carousel',{staticClass:"full-width",attrs:{"per-page":1}},_vm._l((_vm.banknote.images),function(image,index){return _c('slide',{key:'image' + index + _vm.banknote.key},[_c('img',{staticClass:"img-responsive",attrs:{"src":image.src,"alt":_vm.banknote.title}})])}))],1):_c('div',[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.banknote.image,"alt":_vm.banknote.title}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.close')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn btn-sm btn-info mr-4",on:{"click":function($event){_vm.$router.replace({ name: 'banknote' })}}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.back'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"float-right hidden-xs"},[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.$router.replace({ name: 'banknote.edit', params: { key: _vm.$route.params.key } })}}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.edit'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","data-toggle":"modal","data-target":"#delete"}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"delete","tabindex":"-1","role":"dialog","aria-labelledby":_vm.banknote.title,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$i18n.t('global.delete')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$i18n.t('banknotes.delete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.no')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.deleteBanknote()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.yes')))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card-profile-stats d-flex justify-content-center"},[_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.banknote.quantity))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))])]),_vm._v(" "),(_vm.banknote.year !== undefined)?_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.banknote.year))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h3',[_c('i',[_vm._v(_vm._s(_vm.banknote.title))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.banknote.book.name))]),_vm._v(" "),_c('div',{staticClass:"h5 font-weight-300 mb-3",staticStyle:{"vertical-align":"middle"}},[(_vm.banknote.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+_vm.banknote.country.toLowerCase()+'/flat/24.png',"alt":_vm.banknote.country}}),_vm._v(" "+_vm._s(_vm.$i18n.t('countries.' + _vm.banknote.country))+",\n                ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$i18n.t('continents.' + _vm.banknote.continent))+"\n              ")]),_vm._v(" "),(_vm.banknote.description)?_c('p',[_vm._v(_vm._s(_vm.banknote.description))]):_vm._e()])])]):_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"card-body pt-10 pt-md-4"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteEdit_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da651f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteEdit_vue__ = __webpack_require__(334);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4da651f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da651f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknote"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-7 pt-5 pt-md-6"}),_vm._v(" "),(_vm.banknote)?_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-xl-4 order-xl-2 mb-5 mb-xl-0"},[_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-3 order-lg-2"},[_c('div',{staticClass:"card-profile-image"},[_c('img',{staticClass:"img-fluid rounded shadow",attrs:{"src":_vm.banknote.image,"alt":_vm.banknote.title}})])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"text-center mt-6"},[_c('h3',[_c('i',[_vm._v(_vm._s(_vm.banknoteEdit.title))])]),_vm._v(" "),_c('div',{staticClass:"h5 font-weight-300"},[(_vm.banknote.country)?_c('span',[_c('img',{attrs:{"src":'https://www.countryflags.io/'+_vm.banknote.country.toLowerCase()+'/flat/24.png',"alt":_vm.banknote.country}}),_vm._v(" "+_vm._s(_vm.$i18n.t('countries.' + _vm.banknote.country))+",\n                ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$i18n.t('continents.' + _vm.banknote.continent))+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-8 order-xl-1"},[_c('div',{staticClass:"card bg-secondary shadow"},[_c('div',{staticClass:"card-header bg-white border-0"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('banknotes.edit')))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.updateBanknote()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: _vm.$route.params.key } })}}},[_vm._v(_vm._s(_vm.$i18n.t('global.cancel')))])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('banknotes.info')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.banknote')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknoteEdit.title),expression:"banknoteEdit.title"}],ref:"title",staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.banknoteEdit.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknoteEdit, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknoteEdit.description),expression:"banknoteEdit.description"}],staticClass:"form-control form-control-alternative",attrs:{"rows":"4"},domProps:{"value":(_vm.banknoteEdit.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknoteEdit, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"quantity"}},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknoteEdit.quantity),expression:"banknoteEdit.quantity"}],ref:"quantity",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.banknoteEdit.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknoteEdit, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"year"}},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknoteEdit.year),expression:"banknoteEdit.year"}],ref:"year",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.banknoteEdit.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknoteEdit, "year", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"book"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.banknoteEdit.book)?_c('span',[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.banknoteEdit.book.name)+"\n                          ")]):_c('span',[_vm._v("\n                            "+_vm._s(_vm.$i18n.t('banknotes.none'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.books),function(book,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectBook(book)}}},[_vm._v(_vm._s(book.name))])}))])])])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('global.images')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group focused"},[_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addImage()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.add'))+"\n                        ")])]),_vm._v(" "),_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col","width":"100"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("URL")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.banknoteEdit.images),function(image,index){return _c('tr',{key:index},[_c('th',{attrs:{"scope":"row","width":"100"}},[_c('div',{staticClass:"media align-items-center"},[_c('a',{staticClass:"mr-3",attrs:{"href":"#"}},[_c('img',{staticClass:"width-100",attrs:{"src":image.src}})])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknoteEdit.images[index].src),expression:"banknoteEdit.images[index].src"}],ref:"images[]",refInFor:true,staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.banknoteEdit.images[index].src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknoteEdit.images[index], "src", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-sm btn-icon-only text-light",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeImage(index)}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete')))])])])])])}))])])])])])])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteNew_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dd6d23_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteNew_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67dd6d23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanknoteNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dd6d23_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanknoteNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Banknote"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),(_vm.continents && _vm.books)?_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-xl-12 order-xl-1"},[_c('div',{staticClass:"card bg-secondary shadow"},[_c('div',{staticClass:"card-header bg-white border-0"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('banknotes.new')))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.addBanknote()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.$router.replace({ name: 'banknote' })}}},[_vm._v(_vm._s(_vm.$i18n.t('global.cancel')))])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('banknotes.info')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.banknote')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknote.title),expression:"banknote.title"}],ref:"title",staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.banknote.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknote, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$i18n.t('global.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknote.description),expression:"banknote.description"}],staticClass:"form-control form-control-alternative",attrs:{"rows":"4"},domProps:{"value":(_vm.banknote.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknote, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"continent"}},[_vm._v(_vm._s(_vm.$i18n.t('global.continent')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                          "+_vm._s(_vm.banknote.continent ? _vm.$i18n.t('continents.'+_vm.banknote.continent) : _vm.$i18n.t('banknotes.none'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.continents),function(continent,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectContinent(continent)}}},[_vm._v(_vm._s(_vm.$i18n.t('continents.'+continent.code)))])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"country"}},[_vm._v(_vm._s(_vm.$i18n.t('global.country')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"disabled":!_vm.countries || _vm.banknote.continent === 'XX',"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                          "+_vm._s(_vm.banknote.country ? _vm.$i18n.t('countries.'+_vm.banknote.country) : _vm.$i18n.t('banknotes.none'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.countries),function(country,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectCountry(country)}}},[_vm._v(_vm._s(_vm.$i18n.t('countries.'+country)))])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"quantity"}},[_vm._v(_vm._s(_vm.$i18n.t('global.quantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknote.quantity),expression:"banknote.quantity"}],ref:"quantity",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.banknote.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknote, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"year"}},[_vm._v(_vm._s(_vm.$i18n.t('global.year')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknote.year),expression:"banknote.year"}],ref:"year",staticClass:"form-control form-control-alternative",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.banknote.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknote, "year", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"book"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.banknote.book)?_c('span',[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.banknote.book.name)+"\n                          ")]):_c('span',[_vm._v("\n                            "+_vm._s(_vm.$i18n.t('banknotes.none'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.books),function(book,index){return _c('a',{key:'book'+index,staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectBook(book)}}},[_vm._v(_vm._s(book.name))])}))])])])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('global.images')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group focused"},[_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addImage()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.add'))+"\n                        ")])]),_vm._v(" "),_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$i18n.t('global.image')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("URL")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.banknote.images),function(image,index){return _c('tr',[_c('th',{key:index,attrs:{"scope":"row"}},[_c('div',{staticClass:"media align-items-center"},[_c('a',{staticClass:"mr-3",attrs:{"href":"#"}},[_c('img',{staticClass:"width-100",attrs:{"src":image.src}})])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.banknote.images[index].src),expression:"banknote.images[index].src"}],ref:"images[]",refInFor:true,staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.banknote.images[index].src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.banknote.images[index], "src", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-sm btn-icon-only text-light",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeImage(index)}}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete')))])])])])])}))])])])])])])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Books_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfb4391_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Books_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cfb4391"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Books_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfb4391_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Books_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.books'))+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-search"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Book"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-6 pt-5 pt-md-6"}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0",staticStyle:{"float":"left"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button","data-toggle":"modal","data-target":"#new"}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"new","tabindex":"-1","role":"dialog","aria-labelledby":_vm.$i18n.t('books.new'),"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.$i18n.t('books.new')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body text-left"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bookNew),expression:"bookNew"}],staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.bookNew)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bookNew=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.close')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.addBook()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))])])])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$i18n.t('books.list')))])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[(_vm.books)?_c('small',[_vm._v(_vm._s(_vm.nbBooks > 1 ? _vm.nbBooks + ' ' + _vm.$i18n.t('global.books').toLowerCase() : _vm.nbBooks + ' ' + _vm.$i18n.t('global.book').toLowerCase()))]):_vm._e()])]),_vm._v(" "),(_vm.books)?_c('div',{attrs:{"id":"listBooks"}},[(_vm.books.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"sort-hover",attrs:{"scope":"col"},on:{"click":function($event){_vm.sort('name')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.book'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{staticClass:"sort-hover",attrs:{"scope":"col"},on:{"click":function($event){_vm.sort('quantity')}}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.t('global.quantity'))+"\n                        "),_c('i',{staticClass:"fas fa-sort"})]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBooks),function(book,index){return _c('tr',{key:book.key},[_c('td',{attrs:{"scope":"row"}},[_c('span',{staticClass:"font-weight-800"},[_vm._v(_vm._s(book.name))])]),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[_vm._v("\n                        "+_vm._s(_vm.$i18n.tc('books.coins', book.nbCoins))+" "),_c('br'),_vm._v("\n                        "+_vm._s(_vm.$i18n.tc('books.banknotes', book.nbBanknotes))+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'book.show', params: { key: book.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.books.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPage == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPage * _vm.pageSize) >= _vm.books.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()]):_c('div',{staticClass:"text-center mt-5 mb-5"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"Loading","width":"75"}})])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookShow_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c2667a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookShow_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57c2667a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c2667a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.books'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Book"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header bg-gradient-primary pb-7 pt-5 pt-md-6"}),_vm._v(" "),(_vm.book)?_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-lg-12 order-xl-2 mb-5 mb-xl-0"},[_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"card-header text-center border-0 pt-4 pt-md-4 pb-4 pb-md-4"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn btn-sm btn-info mr-4",on:{"click":function($event){_vm.$router.replace({ name: 'book' })}}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.back'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"data-toggle":"modal","data-target":"#edit"}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.edit'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"edit","tabindex":"-1","role":"dialog","aria-labelledby":_vm.book.name,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.$i18n.t('books.edit')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body text-left"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$i18n.t('global.book')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bookEdit),expression:"bookEdit"}],staticClass:"form-control form-control-alternative",attrs:{"type":"text"},domProps:{"value":(_vm.bookEdit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bookEdit=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.close')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.updateBook()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.save')))])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","data-toggle":"modal","data-target":"#delete"}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"delete","tabindex":"-1","role":"dialog","aria-labelledby":_vm.book.name,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$i18n.t('global.delete')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$i18n.t('books.delete')))]),_vm._v(" "),_c('p',{staticClass:"font-weight-900"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.$i18n.t('books.delete2')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$i18n.t('global.no')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.deleteBook()}}},[_vm._v(_vm._s(_vm.$i18n.t('global.yes')))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"font-weight-800"},[_c('i',[_vm._v(_vm._s(_vm.book.name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card-profile-stats d-flex justify-content-center"},[_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.book.nbCoins)+" "),_c('i',{staticClass:"fas fa-coins"})]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.coins')))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.book.nbBanknotes)+" "),_c('i',{staticClass:"far fa-money-bill-alt"})]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.banknotes')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-6 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0"},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("\n                          "+_vm._s(_vm.$i18n.t('global.coins'))+"\n                        ")]),_vm._v(" "),(_vm.book.coins.length > 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCoin),expression:"searchCoin"}],staticClass:"form-control form-control-alternative mt-2",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.searchCoin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCoin=$event.target.value}}}):_vm._e()]),_vm._v(" "),(_vm.book.coins.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$i18n.t('global.coin')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCoins),function(coin,index){return _c('tr',{key:coin.key},[_c('th',{attrs:{"scope":"row"}},[_c('div',{staticClass:"media align-items-center"},[_c('div',{staticClass:"avatar rounded-circle mr-3"},[_c('img',{attrs:{"alt":coin.title,"src":coin.image}})]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('span',{staticClass:"mb-0 text-sm"},[_vm._v(_vm._s(coin.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.tc('books.coins', coin.quantity)))])])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'coin.show', params: { key: coin.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.book.coins.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPageCoin == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPageCoin}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPageCoin * _vm.pageSizeCoin) >= _vm.book.coins.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPageCoin}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-6 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"mb-0"},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"margin":"0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.new' })}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("\n                          "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n                        ")]),_vm._v(" "),(_vm.book.banknotes.length > 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBanknote),expression:"searchBanknote"}],staticClass:"form-control form-control-alternative mt-2",attrs:{"type":"text","placeholder":_vm.$i18n.t('global.search')},domProps:{"value":(_vm.searchBanknote)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBanknote=$event.target.value}}}):_vm._e()]),_vm._v(" "),(_vm.book.banknotes.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table align-items-center table-flush"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$i18n.t('global.banknote')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBanknotes),function(banknote,index){return _c('tr',{key:banknote.key},[_c('th',{attrs:{"scope":"row"}},[_c('div',{staticClass:"media align-items-center"},[_c('div',{staticClass:"mr-3"},[_c('img',{staticClass:"width-100",attrs:{"alt":banknote.title,"src":banknote.image}})]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('span',{staticClass:"mb-0 text-sm"},[_vm._v(_vm._s(banknote.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.tc('books.banknotes', banknote.quantity)))])])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin":"5px 0 0 0 !important"},attrs:{"type":"button"},on:{"click":function($event){_vm.$router.replace({ name: 'banknote.show', params: { key: banknote.key } })}}},[_c('i',{staticClass:"far fa-eye"})])])])}))])]):_vm._e(),_vm._v(" "),(_vm.book.banknotes.length > 0)?_c('div',{staticClass:"card-footer py-4"},[_c('nav',[_c('ul',{staticClass:"pagination justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ 'disabled': _vm.currentPageBanknote == 1 }},[_c('div',{staticClass:"page-link",on:{"click":_vm.prevPageBanknote}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ 'disabled': (_vm.currentPageBanknote * _vm.pageSizeBanknote) >= _vm.book.banknotes.length }},[_c('div',{staticClass:"page-link",on:{"click":_vm.nextPageBanknote}},[_c('i',{staticClass:"fas fa-angle-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])]):_vm._e()])])])])])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6398e5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b6398e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b6398e5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" "+_vm._s(_vm.$i18n.t('user.profile'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav align-items-center d-none d-md-flex"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link pr-0",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-body ml-2 d-none d-lg-block"},[_c('span',{staticClass:"mb-0 text-sm  font-weight-bold"},[_vm._v(_vm._s(_vm.user ? _vm.user.displayName : ''))])])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"User"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"header pb-8 pt-5 pt-lg-8 d-flex align-items-center",staticStyle:{"min-height":"600px","background-image":"url(https://images.unsplash.com/photo-1521897258701-21e2a01f5e8b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80)","background-size":"cover","background-position":"center top"}},[_c('span',{staticClass:"mask bg-gradient-default opacity-8"}),_vm._v(" "),_c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"display-2 text-white mt-0 mb-5"},[_vm._v("Hello "+_vm._s(_vm.user && _vm.user.displayName ? _vm.user.displayName : ''))])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 order-xl-2 mb-5 mb-xl-0"},[_c('div',{staticClass:"card card-profile shadow"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-3 order-lg-2"},[_c('div',{staticClass:"card-profile-image"},[(_vm.user && _vm.user.photoURL)?_c('button',{staticClass:"border-0",attrs:{"type":"button","data-toggle":"modal","data-target":"#photoURL"}},[_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.user.photoURL,"alt":_vm.user.displayName,"id":"user-image"}})]):_vm._e()]),_vm._v(" "),(_vm.user)?_c('div',{staticClass:"modal fade",attrs:{"id":"photoURL","tabindex":"-1","role":"dialog","aria-labelledby":_vm.user.displayName,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$i18n.t('user.photo')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.user.photoURL,"alt":_vm.user.displayName}})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"}),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pt-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card-profile-stats d-flex justify-content-center mt-md-5"},[_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.booksCount))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.books')))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.coinsCount))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.coins')))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.banknotesCount))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$i18n.t('global.banknotes')))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-8 order-xl-1"},[_c('div',{staticClass:"card bg-secondary shadow"},[_c('div',{staticClass:"card-header bg-white border-0"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$i18n.t('user.profile')))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"})])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('user.info')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group focused"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"input-username"}},[_vm._v(_vm._s(_vm.$i18n.t('user.displayName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editUser.displayName),expression:"editUser.displayName"}],staticClass:"form-control form-control-alternative",attrs:{"type":"text","id":"input-username"},domProps:{"value":(_vm.editUser.displayName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editUser, "displayName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-control-label",attrs:{"for":"input-email"}},[_vm._v(_vm._s(_vm.$i18n.t('user.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editUser.email),expression:"editUser.email"}],staticClass:"form-control form-control-alternative",attrs:{"type":"email","id":"input-email"},domProps:{"value":(_vm.editUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editUser, "email", $event.target.value)}}})])])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h6',{staticClass:"heading-small text-muted mb-4"},[_vm._v(_vm._s(_vm.$i18n.t('user.photo')))]),_vm._v(" "),_c('div',{staticClass:"pl-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group input-group-alternative"},[_c('div',{staticClass:"dropdown full-width"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle full-width bg-white",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(_vm.editUser.photoURL)?_c('span',[_c('i',{staticClass:"far fa-thumbs-up"})]):_c('span',[_vm._v("\n                              "+_vm._s(_vm.$i18n.t('register.choose_image'))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu full-width",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})]),_vm._v(" "),_c('a',{staticClass:"dropdown-item full-width",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectPhotoURL('https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')}}},[_c('img',{staticClass:"full-width",attrs:{"src":"https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80","alt":"Image"}})])])])])])])])])])])])])]),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__country__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coin__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continent__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__banknote__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__book__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_cookie__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    country: __WEBPACK_IMPORTED_MODULE_3__country__["a" /* default */],
    continent: __WEBPACK_IMPORTED_MODULE_5__continent__["a" /* default */],
    coin: __WEBPACK_IMPORTED_MODULE_4__coin__["a" /* default */],
    banknote: __WEBPACK_IMPORTED_MODULE_6__banknote__["a" /* default */],
    book: __WEBPACK_IMPORTED_MODULE_7__book__["a" /* default */]
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate__["a" /* default */])({
    storage: {
      getItem: function getItem(key) {
        return __WEBPACK_IMPORTED_MODULE_9_js_cookie__["getJSON"](key);
      },
      setItem: function setItem(key, value) {
        return __WEBPACK_IMPORTED_MODULE_9_js_cookie__["set"](key, value, { secure: true });
      },
      removeItem: function removeItem(key) {
        return __WEBPACK_IMPORTED_MODULE_9_js_cookie__["remove"](key);
      }
    }
  })]
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(62);








var state = {
  user: null,
  error: null
};

var mutations = {
  setUser: function setUser(state, payload) {
    state.user = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  }
};

var actions = {
  userUpdate: function userUpdate(_ref, payload) {
    var commit = _ref.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    var currentUser = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser;
    var promises = [];
    if (tokenUser) {
      if (payload !== undefined) {
        if (payload.editUser && payload.key) {
          if (payload.editUser.email !== payload.currentUser.email) {
            var promiseUpdateEmail = currentUser.updateEmail(payload.editUser.email);
            promises.push(promiseUpdateEmail);
          }
          if (payload.editUser.password !== payload.currentUser.password) {
            var promiseUpdatePassword = currentUser.updatePassword(payload.editUser.password);
            promises.push(promiseUpdatePassword);
          }
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            var updated = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.database().ref('users').child(payload.key).update(payload.editUser);
            if (updated) {
              window.location.reload();
            }
          });
        }
      }
    }
  },
  userRegister: function userRegister(_ref2, payload) {
    var commit = _ref2.commit;

    if (payload !== undefined) {
      if (payload.email && payload.password) {
        __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(function (response) {
          if (response.user) {
            var data = {
              uid: response.user.uid,
              displayName: payload.displayName,
              email: payload.email,
              photoURL: payload.photoURL,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString()
            };
            __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.database().ref('users').push().set(data);
            if (!localStorage.getItem('user')) {
              localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.user));
            }
            commit('setUser', data);
          }
        }).catch(function (err) {
          return commit('setError', err.message);
        });
      }
    }
  },
  fetchUser: function fetchUser(_ref3) {
    var commit = _ref3.commit;

    commit('setUser', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser) {
      __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.database().ref('users').orderByChild('uid').equalTo(tokenUser).once('value').then(function (snapshot) {
        var user = snapshot.val();
        user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(user).map(function (_ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        });
        commit('setUser', user[0]);
      }).catch(function (err) {
        return commit('setError', err.message);
      });
    }
  },
  userLogin: function userLogin(_ref6, payload) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (response) {
      if (!localStorage.getItem('user')) {
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.user));
      }
      commit('setUser', response.user);
      commit('setError', null);
    }).catch(function (err) {
      return commit('setError', err.message);
    });
  },
  userLogout: function userLogout(_ref7, payload) {
    var commit = _ref7.commit;

    if (localStorage.getItem('user')) {
      localStorage.removeItem('user');
    }
    __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().signOut().then(function () {
      commit('setUser', null);
      commit('setError', null);
    }).catch(function (err) {
      return commit('setError', err.message);
    });
  },
  checkUserStatus: function checkUserStatus(_ref8) {
    var commit = _ref8.commit;

    // if (localStorage.getItem('user')) {
    //   let localUser = JSON.parse(localStorage.getItem('user'))
    //   commit('setUser', localUser)
    // }
    commit('setUser', null);
    __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        commit('setUser', user);
      }
    });
  }
};

var getters = {
  user: function user(state) {
    return state.user;
  },
  error: function error(state) {
    return state.error;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(62);







var state = {
  country: null,
  countries: null,
  countriesByContinent: null,
  countriesAmcharts: [],
  errorCountry: null,
  errorByContinent: null
};

var mutations = {
  setCountry: function setCountry(state, payload) {
    state.country = payload;
  },
  setCountries: function setCountries(state, payload) {
    state.countries = payload;
  },
  setCountriesByContinent: function setCountriesByContinent(state, payload) {
    state.countriesByContinent = payload;
  },
  setCountriesAmcharts: function setCountriesAmcharts(state, payload) {
    state.countriesAmcharts = payload;
  },
  setErrorCountry: function setErrorCountry(state, payload) {
    state.errorCountry = payload;
  },
  setErrorByContinent: function setErrorByContinent(state, payload) {
    state.errorByContinent = payload;
  }
};

var actions = {
  fetchCountry: function fetchCountry(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').orderByChild('code').equalTo(payload.code).once('value').then(function (snapshot) {
      return commit('setCountry', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(snapshot.val()).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
      })[0]);
    }).catch(function (err) {
      return commit('setErrorCountry', err.message);
    });
  },
  fetchCountries: function fetchCountries(_ref4, payload) {
    var commit = _ref4.commit;

    var promiseCountries = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries');
    if (payload !== undefined) {
      if (payload.codeContinent) {
        promiseCountries = promiseCountries.orderByChild('continent').equalTo(payload.codeContinent.toUpperCase());
      }
    }
    promiseCountries.once('value').then(function (snapshot) {
      return commit('setCountries', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(snapshot.val()).map(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
      }));
    }).catch(function (err) {
      return commit('setErrorCountry', err.message);
    });
  },
  fetchCountriesByContinent: function fetchCountriesByContinent(_ref7, payload) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').orderByChild('continent').equalTo(payload).once('value').then(function (snapshot) {
      return commit('setCountriesByContinent', snapshot.val());
    }).catch(function (err) {
      return commit('setErrorByContinent', err.message);
    });
  },
  fetchCountriesAmcharts: function fetchCountriesAmcharts(_ref8) {
    var commit = _ref8.commit;

    var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').once('value');
    var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').once('value');
    var promiseCountries = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').once('value');
    var arr = [];

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseCountries, promiseBanknotes]).then(function (data) {
      var coins = data[0].val();
      var countries = data[1].val();
      var banknotes = data[2].val();
      var arrCoins = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
      });
      var arrBanknotes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref11) {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
            key = _ref12[0],
            value = _ref12[1];

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
      });

      var _loop = function _loop(i) {
        var coinsByCountry = arrCoins.filter(function (coin) {
          return coin.country === countries[i].code;
        });
        var banknotesByCountry = arrBanknotes.filter(function (banknote) {
          return banknote.country === countries[i].code;
        });
        arr.push({
          'id': countries[i].code,
          'name': countries[i].name,
          'nbCoins': Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(coinsByCountry),
          'nbBanknotes': Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(banknotesByCountry)
        });
      };

      for (var i in countries) {
        _loop(i);
      }
      commit('setCountriesAmcharts', arr);
    });
  }
};

var getters = {
  country: function country(state) {
    return state.country;
  },
  countries: function countries(state) {
    return state.countries;
  },
  errorCountry: function errorCountry(state) {
    return state.errorCountry;
  },
  countriesByContinent: function countriesByContinent(state) {
    return state.countriesByContinent;
  },
  countriesAmcharts: function countriesAmcharts(state) {
    return state.countriesAmcharts;
  },
  errorByContinent: function errorByContinent(state) {
    return state.errorByContinent;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(62);







var state = {
  coin: null,
  coins: null,
  coinsCount: 0,
  coinsByCountry: null,
  coinsByContinent: null,
  errorCoins: null
};

var mutations = {
  setCoin: function setCoin(state, payload) {
    state.coin = payload;
  },
  setCoins: function setCoins(state, payload) {
    state.coins = payload;
  },
  setCoinsCount: function setCoinsCount(state, payload) {
    state.coinsCount = payload;
  },
  setCoinsByCountry: function setCoinsByCountry(state, payload) {
    state.coinsByCountry = payload;
  },
  setCoinsByContinent: function setCoinsByContinent(state, payload) {
    state.coinsByContinent = payload;
  },
  setErrorCoins: function setErrorCoins(state, payload) {
    state.errorCoins = payload;
  }
};

var actions = {
  addCoin: function addCoin(_ref, payload) {
    var commit = _ref.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.data) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').push().set(payload.data);
    }
  },
  updateCoin: function updateCoin(_ref2, payload) {
    var commit = _ref2.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.data && payload.key) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').child(payload.key).update(payload.data);
    }
  },
  deleteCoin: function deleteCoin(_ref3, payload) {
    var commit = _ref3.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.key) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').child(payload.key).remove();
    }
  },
  fetchCoin: function fetchCoin(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setCoin', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      if (payload !== undefined && payload.key) {
        var promiseCoin = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').child(payload.key).once('value');
        var promiseBooks = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').once('value');

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseCoin, promiseBooks]).then(function (data) {
          var coin = data[0] ? data[0].val() : null;
          var books = data[1] ? data[1].val() : null;
          var arrBooks = books ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref5) {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
          }).filter(function (book) {
            return book.id === coin.book;
          }) : [];

          if (arrBooks.length > 0) {
            coin.book = arrBooks[arrBooks.length - 1];
          }
          if (coin.uid === tokenUser) {
            commit('setCoin', coin);
          }
        });
      }
    }
  },
  fetchCoins: function fetchCoins(_ref7, payload) {
    var commit = _ref7.commit;

    commit('setCoins', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins');
      if (payload !== undefined) {
        if (payload.countryCode) {
          promiseCoins = promiseCoins.orderByChild('country').equalTo(payload.countryCode);
        }
        if (payload.continentCode) {
          promiseCoins = promiseCoins.orderByChild('continent').equalTo(payload.continentCode);
        }
      }
      promiseCoins = promiseCoins.once('value');
      var promiseBooks = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').once('value');

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseBooks]).then(function (data) {
        var coins = data[0] ? data[0].val() : null;
        var books = data[1] ? data[1].val() : null;
        var arrCoins = coins ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref8) {
          var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
              key = _ref9[0],
              value = _ref9[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrBooks = books ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref10) {
          var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
              key = _ref11[0],
              value = _ref11[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var coinsUser = arrCoins.length > 0 ? arrCoins.filter(function (coin) {
          return coin.uid === tokenUser;
        }) : [];

        if (coinsUser.length > 0) {
          var _loop = function _loop(i) {
            coinsUser[i].book = arrBooks.filter(function (book) {
              return book.id === coinsUser[i].book;
            })[0];
          };

          for (var i in coinsUser) {
            _loop(i);
          }
        }
        commit('setCoins', coinsUser);
      });
    }
  },
  fetchCoinsCount: function fetchCoinsCount(_ref12) {
    var commit = _ref12.commit;

    commit('setCoinsCount', 0);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').orderByChild('uid').equalTo(tokenUser).once('value').then(function (snapshot) {
        var coins = snapshot.val();
        var arrCoins = coins ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref13) {
          var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
              key = _ref14[0],
              value = _ref14[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        commit('setCoinsCount', Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(arrCoins));
      }).catch(function (err) {
        return commit('setErrorCoins', err.message);
      });
    }
  },
  fetchCoinsByCountry: function fetchCoinsByCountry(_ref15, payload) {
    var commit = _ref15.commit;

    commit('setCoinsByCountry', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').once('value');
      var promiseCountries = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').once('value');
      var arr = [];

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseCountries]).then(function (data) {
        var coins = data[0].val();
        var countries = data[1].val();
        var arrCoins = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref16) {
          var _ref17 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
              key = _ref17[0],
              value = _ref17[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        });

        var _loop2 = function _loop2(i) {
          var coinsByCountry = arrCoins.filter(function (coin) {
            return coin.country === countries[i].code && coin.uid === tokenUser;
          });
          arr.push({
            'id': countries[i].code,
            'name': countries[i].name,
            'native': countries[i].native,
            'nbCoins': Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(coinsByCountry)
          });
        };

        for (var i in countries) {
          _loop2(i);
        }
        commit('setCoinsByCountry', arr);
      });
    }
  },
  fetchCoinsByContinent: function fetchCoinsByContinent(_ref18, payload) {
    var commit = _ref18.commit;

    commit('setCoinsByContinent', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins');
      if (payload.idContinent) {
        promiseCoins = promiseCoins.orderByChild('continent').equalTo(payload.idContinent);
      }
      promiseCoins = promiseCoins.once('value');
      var promiseContinent = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('continents').once('value');
      var arr = [];

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseContinent]).then(function (data) {
        var coins = data[0].val();
        var continents = data[1].val();
        var arrCoins = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref19) {
          var _ref20 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref19, 2),
              key = _ref20[0],
              value = _ref20[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        });

        var _loop3 = function _loop3(i) {
          var coinsByContinent = arrCoins.filter(function (coin) {
            return coin.continent === continents[i].code && coin.uid === tokenUser;
          });
          arr.push({
            'id': continents[i].code,
            'name': continents[i].name,
            'nbCoins': Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(coinsByContinent)
          });
        };

        for (var i in continents) {
          _loop3(i);
        }
        commit('setCoinsByContinent', arr);
      });
    }
  }
};

var getters = {
  coin: function coin(state) {
    return state.coin;
  },
  coins: function coins(state) {
    return state.coins;
  },
  coinsCount: function coinsCount(state) {
    return state.coinsCount;
  },
  coinsByCountry: function coinsByCountry(state) {
    return state.coinsByCountry;
  },
  coinsByContinent: function coinsByContinent(state) {
    return state.coinsByContinent;
  },
  errorCoins: function errorCoins(state) {
    return state.errorCoins;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(62);







var state = {
  continent: null,
  continents: null,
  errorContinent: null,
  coinsBanknotesByContinent: null
};

var mutations = {
  setContinent: function setContinent(state, payload) {
    state.continent = payload;
  },
  setContinents: function setContinents(state, payload) {
    state.continents = payload;
  },
  setErrorContinent: function setErrorContinent(state, payload) {
    state.errorContinent = payload;
  },
  setCoinsBanknotesByContinent: function setCoinsBanknotesByContinent(state, payload) {
    state.coinsBanknotesByContinent = payload;
  }
};

var actions = {
  fetchContinent: function fetchContinent(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('continents').orderByChild('code').equalTo(payload.code).once('value').then(function (snapshot) {
      return commit('setContinent', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(snapshot.val()).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
      })[0]);
    }).catch(function (err) {
      return commit('setErrorContinent', err.message);
    });
  },
  fetchContinents: function fetchContinents(_ref4, payload) {
    var commit = _ref4.commit;

    if (payload !== undefined && payload.withCountries) {
      var promiseContinents = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('continents').once('value');
      var promiseCountries = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').once('value');
      var arr = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([promiseContinents, promiseCountries]).then(function (data) {
        var continents = data[0] ? data[0].val() : null;
        var countries = data[1] ? data[1].val() : null;

        var arrCountries = countries ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(countries).map(function (_ref5) {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrContinents = continents ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(continents).map(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              key = _ref8[0],
              value = _ref8[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        if (arrContinents.length > 0) {
          var _loop = function _loop(i) {
            arr.push({
              code: arrContinents[i].code,
              countries: arrCountries.filter(function (country) {
                return country.continent === arrContinents[i].code;
              }).map(function (country) {
                return country.code;
              })
            });
          };

          for (var i in arrContinents) {
            _loop(i);
          }
        }
        commit('setContinents', arr);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('continents').once('value').then(function (snapshot) {
        return commit('setContinents', snapshot.val());
      }).catch(function (err) {
        return commit('setErrorContinent', err.message);
      });
    }
  },
  fetchCoinsBanknotesByContinent: function fetchCoinsBanknotesByContinent(_ref9) {
    var commit = _ref9.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').orderByChild('uid').equalTo(tokenUser).once('value');
      var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').orderByChild('uid').equalTo(tokenUser).once('value');
      var promiseContinent = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('continents').once('value');
      var promiseCountries = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('countries').once('value');
      var arr = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseContinent, promiseBanknotes, promiseCountries]).then(function (data) {
        var coins = data[0] ? data[0].val() : null;
        var continents = data[1] ? data[1].val() : null;
        var banknotes = data[2] ? data[2].val() : null;
        var countries = data[3] ? data[3].val() : null;
        var arrCoins = coins ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref10) {
          var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
              key = _ref11[0],
              value = _ref11[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrBanknotes = banknotes ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref12) {
          var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref12, 2),
              key = _ref13[0],
              value = _ref13[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrCountries = countries ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(countries).map(function (_ref14) {
          var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
              key = _ref15[0],
              value = _ref15[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrContinents = continents ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(continents).map(function (_ref16) {
          var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
              key = _ref17[0],
              value = _ref17[1];

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];

        if (arrContinents.length > 0) {
          var _loop2 = function _loop2(i) {
            var coinsByContinent = arrCoins.filter(function (coin) {
              return coin.continent === arrContinents[i].code;
            });
            var banknotesByContinent = arrBanknotes.filter(function (banknote) {
              return banknote.continent === arrContinents[i].code;
            });
            var filteredCountries = arrCountries.filter(function (country) {
              return country.continent === arrContinents[i].code;
            });
            arr.push({
              id: arrContinents[i].code,
              name: arrContinents[i].name,
              color: arrContinents[i].color,
              nbCoins: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(coinsByContinent),
              nbBanknotes: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(banknotesByContinent),
              coins: function coins() {
                var filteredCoins = [];

                var _loop3 = function _loop3(_i) {
                  var filteredCoinsByCountry = arrCoins.filter(function (coin) {
                    return coin.country === filteredCountries[_i].code;
                  });
                  filteredCoins.push({
                    code: filteredCountries[_i].code,
                    country: filteredCountries[_i].name,
                    quantity: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(filteredCoinsByCountry)
                  });
                };

                for (var _i in filteredCountries) {
                  _loop3(_i);
                }
                return filteredCoins;
              },
              banknotes: function banknotes() {
                var filteredBanknotes = [];

                var _loop4 = function _loop4(_i2) {
                  var filteredBanknotesByCountry = arrBanknotes.filter(function (banknote) {
                    return banknote.country === filteredCountries[_i2].code;
                  });
                  filteredBanknotes.push({
                    code: filteredCountries[_i2].code,
                    country: filteredCountries[_i2].name,
                    quantity: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(filteredBanknotesByCountry)
                  });
                };

                for (var _i2 in filteredCountries) {
                  _loop4(_i2);
                }
                return filteredBanknotes;
              }
            });
          };

          for (var i in arrContinents) {
            _loop2(i);
          }
        }
        commit('setCoinsBanknotesByContinent', arr);
      });
    }
  }
};

var getters = {
  continent: function continent(state) {
    return state.continent;
  },
  continents: function continents(state) {
    return state.continents;
  },
  coinsBanknotesByContinent: function coinsBanknotesByContinent(state) {
    return state.coinsBanknotesByContinent;
  },
  errorContinent: function errorContinent(state) {
    return state.errorContinent;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(62);







var state = {
  banknote: null,
  banknotes: null,
  banknotesCount: 0,
  errorBanknotes: null
};

var mutations = {
  setBanknote: function setBanknote(state, payload) {
    state.banknote = payload;
  },
  setBanknotes: function setBanknotes(state, payload) {
    state.banknotes = payload;
  },
  setBanknotesCount: function setBanknotesCount(state, payload) {
    state.banknotesCount = payload;
  },
  setErrorBanknotes: function setErrorBanknotes(state, payload) {
    state.errorBanknotes = payload;
  }
};

var actions = {
  addBanknote: function addBanknote(_ref, payload) {
    var commit = _ref.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.data) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').push().set(payload.data);
    }
  },
  updateBanknote: function updateBanknote(_ref2, payload) {
    var commit = _ref2.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.data && payload.key) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').child(payload.key).update(payload.data);
    }
  },
  deleteBanknote: function deleteBanknote(_ref3, payload) {
    var commit = _ref3.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser && payload.key) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').child(payload.key).remove();
    }
  },
  fetchBanknote: function fetchBanknote(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setBanknote', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      if (payload !== undefined && payload.key) {
        var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').child(payload.key).once('value');
        var promiseBooks = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').once('value');

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseBanknotes, promiseBooks]).then(function (data) {
          var banknote = data[0] ? data[0].val() : null;
          var books = data[1] ? data[1].val() : null;
          var arrBooks = books ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref5) {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
          }).filter(function (book) {
            return book.id === banknote.book;
          }) : [];

          if (arrBooks.length > 0) {
            banknote.book = arrBooks[arrBooks.length - 1];
          }
          if (banknote.uid === tokenUser) {
            commit('setBanknote', banknote);
          }
        });
      }
    }
  },
  fetchBanknotes: function fetchBanknotes(_ref7, payload) {
    var commit = _ref7.commit;

    commit('setBanknotes', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes');
      if (payload !== undefined) {
        if (payload.countryCode) {
          promiseBanknotes = promiseBanknotes.orderByChild('country').equalTo(payload.countryCode);
        }
        if (payload.continentCode) {
          promiseBanknotes = promiseBanknotes.orderByChild('continent').equalTo(payload.continentCode);
        }
      }
      promiseBanknotes = promiseBanknotes.once('value');
      var promiseBooks = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').once('value');

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseBanknotes, promiseBooks]).then(function (data) {
        var banknotes = data[0] ? data[0].val() : null;
        var books = data[1] ? data[1].val() : null;
        var arrBanknotes = banknotes ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref8) {
          var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
              key = _ref9[0],
              value = _ref9[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrBooks = books ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref10) {
          var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
              key = _ref11[0],
              value = _ref11[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var banknotesUser = arrBanknotes.length > 0 ? arrBanknotes.filter(function (banknote) {
          return banknote.uid === tokenUser;
        }) : [];

        if (banknotesUser.length > 0) {
          var _loop = function _loop(i) {
            banknotesUser[i].book = arrBooks.filter(function (book) {
              return book.id === banknotesUser[i].book;
            })[0];
          };

          for (var i in banknotesUser) {
            _loop(i);
          }
        }
        commit('setBanknotes', banknotesUser);
      });
    }
  },
  fetchBanknotesCount: function fetchBanknotesCount(_ref12) {
    var commit = _ref12.commit;

    commit('setBanknotesCount', 0);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getToken */])();
    if (tokenUser) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').orderByChild('uid').equalTo(tokenUser).once('value').then(function (snapshot) {
        var banknotes = snapshot.val();
        var arrBanknotes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref13) {
          var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
              key = _ref14[0],
              value = _ref14[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        });
        commit('setBanknotesCount', Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getQuantity */])(arrBanknotes));
      }).catch(function (err) {
        return commit('setErrorBanknotes', err.message);
      });
    }
  }
};

var getters = {
  banknote: function banknote(state) {
    return state.banknote;
  },
  banknotes: function banknotes(state) {
    return state.banknotes;
  },
  banknotesCount: function banknotesCount(state) {
    return state.banknotesCount;
  },
  errorBanknotes: function errorBanknotes(state) {
    return state.errorBanknotes;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(62);








var state = {
  book: null,
  books: null,
  maxBook: null,
  errorBooks: null
};

var mutations = {
  setBook: function setBook(state, payload) {
    state.book = payload;
  },
  setBooks: function setBooks(state, payload) {
    state.books = payload;
  },
  setMaxBook: function setMaxBook(state, payload) {
    state.maxBook = payload;
  },
  setErrorBooks: function setErrorBooks(state, payload) {
    state.errorBooks = payload;
  }
};

var actions = {
  addBook: function addBook(_ref, payload) {
    var commit = _ref.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser && payload.data) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').push().set(payload.data);
    }
  },
  updateBook: function updateBook(_ref2, payload) {
    var commit = _ref2.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser && payload.name && payload.key) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').child(payload.key).update({
        name: payload.name,
        updated_at: new Date().toISOString()
      });
    }
  },
  deleteBook: function deleteBook(_ref3, payload) {
    var commit = _ref3.commit;

    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser) {
      if (payload !== undefined && payload.key && payload.bookId) {
        var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').orderByChild('book').equalTo(payload.bookId).once('value');
        var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').orderByChild('book').equalTo(payload.bookId).once('value');
        var promiseBook = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').child(payload.key).once('value');

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseCoins, promiseBanknotes, promiseBook]).then(function (data) {
          var coins = data[0];
          var banknotes = data[1];
          var book = data[2];
          if (coins) {
            coins.forEach(function (coin) {
              return coin.ref.remove();
            });
          }
          if (banknotes) {
            banknotes.forEach(function (banknote) {
              return banknote.ref.remove();
            });
          }
          if (book) {
            book.ref.remove();
          }
          window.location.href = '/books';
        });
      }
    }
  },
  fetchBook: function fetchBook(_ref4, payload) {
    var commit = _ref4.commit;

    commit('setBook', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser) {
      if (payload !== undefined && payload.key) {
        var promiseBook = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').child(payload.key).once('value');
        var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').once('value');
        var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').once('value');

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseBook, promiseCoins, promiseBanknotes]).then(function (data) {
          var book = data[0] ? data[0].val() : null;
          var coins = data[1] ? data[1].val() : null;
          var banknotes = data[2] ? data[2].val() : null;

          var arrCoins = coins ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref5) {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
          }) : [];
          var arrBanknotes = banknotes ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref7) {
            var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
                key = _ref8[0],
                value = _ref8[1];

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
          }) : [];

          if (book) {
            book.coins = arrCoins.filter(function (coin) {
              return coin.book === book.id;
            });
            book.nbCoins = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getQuantity */])(book.coins);
            book.banknotes = arrBanknotes.filter(function (banknote) {
              return banknote.book === book.id;
            });
            book.nbBanknotes = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getQuantity */])(book.banknotes);
            commit('setBook', book);
          }
        });
      }
    }
  },
  fetchBooks: function fetchBooks(_ref9) {
    var commit = _ref9.commit;

    commit('setBooks', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser) {
      var promiseBooks = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').orderByChild('uid').equalTo(tokenUser).once('value');
      var promiseCoins = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('coins').once('value');
      var promiseBanknotes = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('banknotes').once('value');

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([promiseBooks, promiseCoins, promiseBanknotes]).then(function (data) {
        var books = data[0] ? data[0].val() : null;
        var coins = data[1] ? data[1].val() : null;
        var banknotes = data[2] ? data[2].val() : null;

        var arrBooks = books ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref10) {
          var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
              key = _ref11[0],
              value = _ref11[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrCoins = coins ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(coins).map(function (_ref12) {
          var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref12, 2),
              key = _ref13[0],
              value = _ref13[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];
        var arrBanknotes = banknotes ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(banknotes).map(function (_ref14) {
          var _ref15 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
              key = _ref15[0],
              value = _ref15[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        }) : [];

        var _loop = function _loop(i) {
          arrBooks[i].coins = arrBooks.length > 0 ? arrCoins.filter(function (coin) {
            return coin.book === arrBooks[i].id;
          }) : [];
          arrBooks[i].nbCoins = arrBooks[i].coins.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getQuantity */])(arrBooks[i].coins) : 0;
          arrBooks[i].banknotes = arrBooks.length > 0 ? arrBanknotes.filter(function (banknote) {
            return banknote.book === arrBooks[i].id;
          }) : [];
          arrBooks[i].nbBanknotes = arrBooks[i].banknotes.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getQuantity */])(arrBooks[i].banknotes) : 0;
        };

        for (var i in arrBooks) {
          _loop(i);
        }
        commit('setBooks', arrBooks);
      });
    }
  },
  fetchMaxBook: function fetchMaxBook(_ref16) {
    var commit = _ref16.commit;

    commit('setMaxBook', null);
    var tokenUser = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getToken */])();
    if (tokenUser) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('books').once('value').then(function (snapshot) {
        var books = snapshot.val();
        var arrBooks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(books).map(function (_ref17) {
          var _ref18 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
              key = _ref18[0],
              value = _ref18[1];

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, value);
        });
        var maxBook = null;
        if (arrBooks.length > 0) {
          maxBook = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.maxBy(arrBooks, 'id');
        }
        commit('setMaxBook', maxBook);
      });
    }
  }
};

var getters = {
  book: function book(state) {
    return state.book;
  },
  books: function books(state) {
    return state.books;
  },
  maxBook: function maxBook(state) {
    return state.maxBook;
  },
  errorBooks: function errorBooks(state) {
    return state.errorBooks;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaces: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fr__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en__ = __webpack_require__(413);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = { en: __WEBPACK_IMPORTED_MODULE_3__en__["a" /* default */], fr: __WEBPACK_IMPORTED_MODULE_2__fr__["a" /* default */] };
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: messages
}));

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continents_fr__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countries_fr__ = __webpack_require__(412);



/* harmony default export */ __webpack_exports__["a"] = ({
  global: {
    dashboard: 'Accueil',
    coins: 'Pièces',
    coin: 'Pièce',
    banknotes: 'Billets',
    banknote: 'Billet',
    books: 'Classeurs',
    book: 'Classeur',
    logout: 'Se déconnecter',
    continent: 'Continent',
    country: 'Pays',
    quantity: 'Quantité',
    year: 'Année',
    image: 'Image',
    images: 'Images',
    save: 'Enregistrer',
    update: 'Modifier',
    close: 'Fermer',
    required: 'Champs obligatoires',
    search: 'Rechercher',
    back: 'Retour',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    add: 'Ajouter',
    yes: 'Oui',
    no: 'Non',
    description: 'Description'
  },
  login: {
    title: 'Bienvenue sur Numisma!',
    subtitle: 'Merci de vous connecter afin d\'accéder à votre trésor',
    credentials: {
      title: 'Connectez-vous avec vos identifiants',
      signin: 'Se connecter'
    },
    forgotten_password: 'Mot de passe oublié ?',
    new_account: 'Nouveau compte',
    email: 'Email',
    password: 'Mot de passe'
  },
  register: {
    title: 'Bienvenue sur Numisma!',
    subtitle: 'Merci de vous connecter afin d\'accéder à votre trésor',
    credentials: {
      title: 'Connectez-vous avec vos identifiants',
      signin: 'Se connecter'
    },
    displayName: 'Identifiant',
    email: 'Email',
    password: 'Mot de passe',
    choose_image: 'Choisir une photo',
    create_account: 'Créer le compte',
    back: 'Retour',
    text: 'Merci de remplir tous les champs du formulaire'
  },
  dashboard: {
    welcome: 'Bienvenue !',
    title: 'Accueil',
    map: 'Carte du monde'
  },
  coins: {
    list: 'Liste des pièces',
    add: 'Ajouter une pièce dans {country}',
    select_continent: 'Sélectionnez un continent',
    select_country: 'Sélectionnez un pays',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer cette pièce ?',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouvelle pièce'
  },
  banknotes: {
    list: 'Liste des billets',
    add: 'Ajouter un billet dans {country}',
    select_continent: 'Sélectionnez un continent',
    select_country: 'Sélectionnez un pays',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer ce billet ?',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouveau billet'
  },
  books: {
    list: 'Liste des classeurs',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer ce classeur ?',
    delete2: 'Attention, tout le contenu du classeur (pièces et billets) seront supprimés',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouveau classeur',
    coins: 'aucune pièce | 1 pièce | {count} pièces',
    banknotes: 'aucun billet | 1 billet | {count} billets'
  },
  user: {
    profile: 'Mon profil',
    info: 'Informations',
    displayName: 'Identifiant',
    email: 'Email',
    password: 'Mot de passe',
    photo: 'Photo de profil',
    firstname: 'Prénom',
    lastname: 'Nom'
  },
  continents: __WEBPACK_IMPORTED_MODULE_0__continents_fr__["a" /* default */],
  countries: __WEBPACK_IMPORTED_MODULE_1__countries_fr__["a" /* default */]
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'AF': 'Afrique',
  'AN': 'Antartique',
  'AS': 'Asie',
  'EU': 'Europe',
  'NA': 'Amérique du Nord',
  'OC': 'Océanie',
  'SA': 'Amérique du Sud',
  'XX': 'Autre'
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'AF': 'Afghanistan',
  'ZA': 'Afrique du Sud',
  'AL': 'Albanie',
  'DZ': 'Algérie',
  'DE': 'Allemagne',
  'AD': 'Andorre',
  'AO': 'Angola',
  'AI': 'Anguilla',
  'AQ': 'Antarctique',
  'AG': 'Antigua-et-Barbuda',
  'AN': 'Antilles néerlandaises',
  'SA': 'Arabie saoudite',
  'AR': 'Argentine',
  'AM': 'Arménie',
  'AW': 'Aruba',
  'AU': 'Australie',
  'AT': 'Autriche',
  'AZ': 'Azerbaïdjan',
  'BS': 'Bahamas',
  'BH': 'Bahreïn',
  'BD': 'Bangladesh',
  'BB': 'Barbade',
  'BY': 'Bélarus',
  'BE': 'Belgique',
  'BZ': 'Belize',
  'BJ': 'Bénin',
  'BM': 'Bermudes',
  'BT': 'Bhoutan',
  'BO': 'Bolivie',
  'BA': 'Bosnie-Herzégovine',
  'BW': 'Botswana',
  'BR': 'Brésil',
  'BN': 'Brunéi Darussalam',
  'BG': 'Bulgarie',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodge',
  'CM': 'Cameroun',
  'CA': 'Canada',
  'CV': 'Cap-Vert',
  'EA': 'Ceuta et Melilla',
  'CL': 'Chili',
  'CN': 'Chine',
  'CY': 'Chypre',
  'CW': 'Curaçao',
  'CO': 'Colombie',
  'KM': 'Comores',
  'CG': 'Congo-Brazzaville',
  'KP': 'Corée du Nord',
  'KR': 'Corée du Sud',
  'CR': 'Costa Rica',
  'CI': 'Côte d’Ivoire',
  'HR': 'Croatie',
  'CU': 'Cuba',
  'DK': 'Danemark',
  'DG': 'Diego Garcia',
  'DJ': 'Djibouti',
  'DM': 'Dominique',
  'EG': 'Égypte',
  'SV': 'El Salvador',
  'AE': 'Émirats arabes unis',
  'EC': 'Équateur',
  'ER': 'Érythrée',
  'ES': 'Espagne',
  'EE': 'Estonie',
  'VA': 'État de la Cité du Vatican',
  'FM': 'États fédérés de Micronésie',
  'US': 'États-Unis',
  'ET': 'Éthiopie',
  'FJ': 'Fidji',
  'FI': 'Finlande',
  'FR': 'France',
  'GA': 'Gabon',
  'GM': 'Gambie',
  'GE': 'Géorgie',
  'GS': 'Géorgie du Sud et les îles Sandwich du Sud',
  'GH': 'Ghana',
  'GI': 'Gibraltar',
  'GR': 'Grèce',
  'GD': 'Grenade',
  'GL': 'Groenland',
  'GP': 'Guadeloupe',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GG': 'Guernesey',
  'GN': 'Guinée',
  'GQ': 'Guinée équatoriale',
  'GW': 'Guinée-Bissau',
  'GY': 'Guyana',
  'GF': 'Guyane française',
  'HT': 'Haïti',
  'HN': 'Honduras',
  'HU': 'Hongrie',
  'BV': 'Île Bouvet',
  'CX': 'Île Christmas',
  'CP': 'Île Clipperton',
  'AC': 'Île de l\'Ascension',
  'IM': 'Île de Man',
  'NF': 'Île Norfolk',
  'AX': 'Îles Åland',
  'KY': 'Îles Caïmans',
  'IC': 'Îles Canaries',
  'CC': 'Îles Cocos - Keeling',
  'CK': 'Îles Cook',
  'FO': 'Îles Féroé',
  'HM': 'Îles Heard et MacDonald',
  'FK': 'Îles Malouines',
  'MP': 'Îles Mariannes du Nord',
  'MH': 'Îles Marshall',
  'UM': 'Îles Mineures Éloignées des États-Unis',
  'SB': 'Îles Salomon',
  'TC': 'Îles Turks et Caïques',
  'VG': 'Îles Vierges britanniques',
  'VI': 'Îles Vierges des États-Unis',
  'IN': 'Inde',
  'ID': 'Indonésie',
  'IQ': 'Irak',
  'IR': 'Iran',
  'IE': 'Irlande',
  'IS': 'Islande',
  'IL': 'Israël',
  'IT': 'Italie',
  'JM': 'Jamaïque',
  'JP': 'Japon',
  'JE': 'Jersey',
  'JO': 'Jordanie',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KG': 'Kirghizistan',
  'KI': 'Kiribati',
  'XK': 'Kosovo',
  'KW': 'Koweït',
  'LA': 'Laos',
  'LS': 'Lesotho',
  'LV': 'Lettonie',
  'LB': 'Liban',
  'LR': 'Libéria',
  'LY': 'Libye',
  'LI': 'Liechtenstein',
  'LT': 'Lituanie',
  'LU': 'Luxembourg',
  'MK': 'Macédoine',
  'MG': 'Madagascar',
  'MY': 'Malaisie',
  'MW': 'Malawi',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malte',
  'MA': 'Maroc',
  'MQ': 'Martinique',
  'MU': 'Maurice',
  'MR': 'Mauritanie',
  'YT': 'Mayotte',
  'MX': 'Mexique',
  'MD': 'Moldavie',
  'MC': 'Monaco',
  'MN': 'Mongolie',
  'ME': 'Monténégro',
  'MS': 'Montserrat',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibie',
  'NR': 'Nauru',
  'NP': 'Népal',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigéria',
  'NU': 'Niue',
  'NO': 'Norvège',
  'NC': 'Nouvelle-Calédonie',
  'NZ': 'Nouvelle-Zélande',
  'OM': 'Oman',
  'UG': 'Ouganda',
  'UZ': 'Ouzbékistan',
  'PK': 'Pakistan',
  'PW': 'Palaos',
  'PA': 'Panama',
  'PG': 'Papouasie-Nouvelle-Guinée',
  'PY': 'Paraguay',
  'NL': 'Pays-Bas',
  'PE': 'Pérou',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Pologne',
  'PF': 'Polynésie française',
  'PR': 'Porto Rico',
  'PT': 'Portugal',
  'QA': 'Qatar',
  'HK': 'R.A.S. chinoise de Hong Kong',
  'MO': 'R.A.S. chinoise de Macao',
  'QO': 'régions éloignées de l’Océanie',
  'CF': 'République centrafricaine',
  'CD': 'République démocratique du Congo',
  'DO': 'République dominicaine',
  'CZ': 'République tchèque',
  'RE': 'Réunion',
  'RO': 'Roumanie',
  'GB': 'Royaume-Uni',
  'RU': 'Russie',
  'RW': 'Rwanda',
  'EH': 'Sahara occidental',
  'BL': 'Saint-Barthélémy',
  'KN': 'Saint-Kitts-et-Nevis',
  'SM': 'Saint-Marin',
  'MF': 'Saint-Martin',
  'PM': 'Saint-Pierre-et-Miquelon',
  'VC': 'Saint-Vincent-et-les Grenadines',
  'SH': 'Sainte-Hélène',
  'LC': 'Sainte-Lucie',
  'WS': 'Samoa',
  'AS': 'Samoa américaines',
  'ST': 'Sao Tomé-et-Principe',
  'SN': 'Sénégal',
  'RS': 'Serbie',
  'CS': 'Serbie-et-Monténégro',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapour',
  'SK': 'Slovaquie',
  'SI': 'Slovénie',
  'SO': 'Somalie',
  'SD': 'Soudan',
  'LK': 'Sri Lanka',
  'SE': 'Suède',
  'CH': 'Suisse',
  'SR': 'Suriname',
  'SJ': 'Svalbard et Île Jan Mayen',
  'SZ': 'Swaziland',
  'SY': 'Syrie',
  'SX': 'Sint Maarten',
  'TJ': 'Tadjikistan',
  'TW': 'Taïwan',
  'TZ': 'Tanzanie',
  'TD': 'Tchad',
  'TF': 'Terres australes françaises',
  'IO': 'Territoire britannique de l\'océan Indien',
  'PS': 'Territoire palestinien',
  'TH': 'Thaïlande',
  'TL': 'Timor oriental',
  'TG': 'Togo',
  'TK': 'Tokelau',
  'TO': 'Tonga',
  'TT': 'Trinité-et-Tobago',
  'TA': 'Tristan da Cunha',
  'TN': 'Tunisie',
  'TM': 'Turkménistan',
  'TR': 'Turquie',
  'TV': 'Tuvalu',
  'UA': 'Ukraine',
  'EU': 'Union européenne',
  'UY': 'Uruguay',
  'VU': 'Vanuatu',
  'VE': 'Venezuela',
  'VN': 'Viêt Nam',
  'WF': 'Wallis-et-Futuna',
  'YE': 'Yémen',
  'ZM': 'Zambie',
  'ZW': 'Zimbabwe',
  'SS': 'Sudan du Sud',
  'BQ': 'Bonaire, Saint-Eustache et Saba'
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continents_en__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countries_en__ = __webpack_require__(415);



/* harmony default export */ __webpack_exports__["a"] = ({
  global: {
    dashboard: 'Dashboard',
    coins: 'Coins',
    coin: 'Coin',
    banknotes: 'Banknotes',
    banknote: 'Banknote',
    books: 'Books',
    book: 'Book',
    logout: 'Logout',
    continent: 'Continent',
    country: 'Country',
    quantity: 'Quantity',
    year: 'Year',
    image: 'Image',
    images: 'Images',
    save: 'Save',
    update: 'Update',
    close: 'Close',
    required: 'Required fields',
    search: 'Search',
    back: 'Back',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    description: 'Description'
  },
  login: {
    title: 'Welcome to Numisma!',
    subtitle: 'Use these awesome forms to login or create new account in your project for free.',
    credentials: {
      title: 'Sign in with credentials',
      signin: 'Sign in'
    },
    forgotten_password: 'Forgotten password?',
    new_account: 'New account',
    email: 'Email',
    password: 'Password'
  },
  register: {
    title: 'Welcome to Numisma!',
    subtitle: 'Use these awesome forms to login or create new account in your project for free.',
    credentials: {
      title: 'Sign in with credentials',
      signin: 'Sign in'
    },
    displayName: 'Username',
    email: 'Email',
    password: 'Password',
    choose_image: 'Choose a picture',
    create_account: 'Create account',
    back: 'Back',
    text: 'Please fill in all fields of the form'
  },
  dashboard: {
    welcome: 'Welcome!',
    title: 'Dashboard',
    map: 'World map'
  },
  coins: {
    list: 'Coins list',
    add: 'Add coin in {country}',
    select_continent: 'Select a continent',
    select_country: 'Select a country',
    none: 'None',
    delete: 'Are you sure you want to delete this coin ?',
    edit: 'Edition',
    info: 'Information',
    new: 'New coin'
  },
  banknotes: {
    list: 'Banknotes list',
    add: 'Add banknote in {country}',
    select_continent: 'Select a continent',
    select_country: 'Select a country',
    none: 'None',
    delete: 'Are you sure you want to delete this banknote ?',
    edit: 'Edition',
    info: 'Information',
    new: 'New banknote'
  },
  books: {
    list: 'Books list',
    none: 'None',
    delete: 'Are you sure you want to delete this book ?',
    delete2: 'Attention, all the contents of the book (coins and banknotes) will be deleted',
    edit: 'Edition',
    info: 'Information',
    new: 'New banknote',
    coins: 'no coin | 1 coin | {count} coins',
    banknotes: 'no banknote | 1 banknote | {count} banknotes'
  },
  user: {
    profile: 'My profile',
    info: 'Information',
    displayName: 'Username',
    email: 'Email',
    password: 'Password',
    photo: 'Photo profile',
    firstname: 'First name',
    lastname: 'Last name'
  },
  continents: __WEBPACK_IMPORTED_MODULE_0__continents_en__["a" /* default */],
  countries: __WEBPACK_IMPORTED_MODULE_1__countries_en__["a" /* default */]
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'AF': 'Africa',
  'AN': 'Antartica',
  'AS': 'Asia',
  'EU': 'Europe',
  'NA': 'North America',
  'OC': 'Oceania',
  'SA': 'South America',
  'XX': 'Other'
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'BD': 'Bangladesh',
  'BE': 'Belgium',
  'BF': 'Burkina Faso',
  'BG': 'Bulgaria',
  'BA': 'Bosnia and Herzegovina',
  'BB': 'Barbados',
  'WF': 'Wallis and Futuna',
  'BL': 'Saint Barthelemy',
  'BM': 'Bermuda',
  'BN': 'Brunei',
  'BO': 'Bolivia',
  'BH': 'Bahrain',
  'BI': 'Burundi',
  'BJ': 'Benin',
  'BT': 'Bhutan',
  'JM': 'Jamaica',
  'BV': 'Bouvet Island',
  'BW': 'Botswana',
  'WS': 'Samoa',
  'BQ': 'Bonaire, Saint Eustatius and Saba',
  'BR': 'Brazil',
  'BS': 'Bahamas',
  'JE': 'Jersey',
  'BY': 'Belarus',
  'BZ': 'Belize',
  'RU': 'Russia',
  'RW': 'Rwanda',
  'RS': 'Serbia',
  'TL': 'East Timor',
  'RE': 'Reunion',
  'TM': 'Turkmenistan',
  'TJ': 'Tajikistan',
  'RO': 'Romania',
  'TK': 'Tokelau',
  'GW': 'Guinea-Bissau',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GS': 'South Georgia and the South Sandwich Islands',
  'GR': 'Greece',
  'GQ': 'Equatorial Guinea',
  'GP': 'Guadeloupe',
  'JP': 'Japan',
  'GY': 'Guyana',
  'GG': 'Guernsey',
  'GF': 'French Guiana',
  'GE': 'Georgia',
  'GD': 'Grenada',
  'GB': 'United Kingdom',
  'GA': 'Gabon',
  'SV': 'El Salvador',
  'GN': 'Guinea',
  'GM': 'Gambia',
  'GL': 'Greenland',
  'GI': 'Gibraltar',
  'GH': 'Ghana',
  'OM': 'Oman',
  'TN': 'Tunisia',
  'JO': 'Jordan',
  'HR': 'Croatia',
  'HT': 'Haiti',
  'HU': 'Hungary',
  'HK': 'Hong Kong',
  'HN': 'Honduras',
  'HM': 'Heard Island and McDonald Islands',
  'VE': 'Venezuela',
  'PR': 'Puerto Rico',
  'PS': 'Palestinian Territory',
  'PW': 'Palau',
  'PT': 'Portugal',
  'SJ': 'Svalbard and Jan Mayen',
  'PY': 'Paraguay',
  'IQ': 'Iraq',
  'PA': 'Panama',
  'PF': 'French Polynesia',
  'PG': 'Papua New Guinea',
  'PE': 'Peru',
  'PK': 'Pakistan',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Poland',
  'PM': 'Saint Pierre and Miquelon',
  'ZM': 'Zambia',
  'EH': 'Western Sahara',
  'EE': 'Estonia',
  'EG': 'Egypt',
  'ZA': 'South Africa',
  'EC': 'Ecuador',
  'IT': 'Italy',
  'VN': 'Vietnam',
  'SB': 'Solomon Islands',
  'ET': 'Ethiopia',
  'SO': 'Somalia',
  'ZW': 'Zimbabwe',
  'SA': 'Saudi Arabia',
  'ES': 'Spain',
  'ER': 'Eritrea',
  'ME': 'Montenegro',
  'MD': 'Moldova',
  'MG': 'Madagascar',
  'MF': 'Saint Martin',
  'MA': 'Morocco',
  'MC': 'Monaco',
  'UZ': 'Uzbekistan',
  'MM': 'Myanmar',
  'ML': 'Mali',
  'MO': 'Macao',
  'MN': 'Mongolia',
  'MH': 'Marshall Islands',
  'MK': 'Macedonia',
  'MU': 'Mauritius',
  'MT': 'Malta',
  'MW': 'Malawi',
  'MV': 'Maldives',
  'MQ': 'Martinique',
  'MP': 'Northern Mariana Islands',
  'MS': 'Montserrat',
  'MR': 'Mauritania',
  'IM': 'Isle of Man',
  'UG': 'Uganda',
  'TZ': 'Tanzania',
  'MY': 'Malaysia',
  'MX': 'Mexico',
  'IL': 'Israel',
  'FR': 'France',
  'IO': 'British Indian Ocean Territory',
  'SH': 'Saint Helena',
  'FI': 'Finland',
  'FJ': 'Fiji',
  'FK': 'Falkland Islands',
  'FM': 'Micronesia',
  'FO': 'Faroe Islands',
  'NI': 'Nicaragua',
  'NL': 'Netherlands',
  'NO': 'Norway',
  'NA': 'Namibia',
  'VU': 'Vanuatu',
  'NC': 'New Caledonia',
  'NE': 'Niger',
  'NF': 'Norfolk Island',
  'NG': 'Nigeria',
  'NZ': 'New Zealand',
  'NP': 'Nepal',
  'NR': 'Nauru',
  'NU': 'Niue',
  'CK': 'Cook Islands',
  'XK': 'Kosovo',
  'CI': 'Ivory Coast',
  'CH': 'Switzerland',
  'CO': 'Colombia',
  'CN': 'China',
  'CM': 'Cameroon',
  'CL': 'Chile',
  'CC': 'Cocos Islands',
  'CA': 'Canada',
  'CG': 'Republic of the Congo',
  'CF': 'Central African Republic',
  'CD': 'Democratic Republic of the Congo',
  'CZ': 'Czech Republic',
  'CY': 'Cyprus',
  'CX': 'Christmas Island',
  'CR': 'Costa Rica',
  'CW': 'Curacao',
  'CV': 'Cape Verde',
  'CU': 'Cuba',
  'SZ': 'Swaziland',
  'SY': 'Syria',
  'SX': 'Sint Maarten',
  'KG': 'Kyrgyzstan',
  'KE': 'Kenya',
  'SS': 'South Sudan',
  'SR': 'Suriname',
  'KI': 'Kiribati',
  'KH': 'Cambodia',
  'KN': 'Saint Kitts and Nevis',
  'KM': 'Comoros',
  'ST': 'Sao Tome and Principe',
  'SK': 'Slovakia',
  'KR': 'South Korea',
  'SI': 'Slovenia',
  'KP': 'North Korea',
  'KW': 'Kuwait',
  'SN': 'Senegal',
  'SM': 'San Marino',
  'SL': 'Sierra Leone',
  'SC': 'Seychelles',
  'KZ': 'Kazakhstan',
  'KY': 'Cayman Islands',
  'SG': 'Singapore',
  'SE': 'Sweden',
  'SD': 'Sudan',
  'DO': 'Dominican Republic',
  'DM': 'Dominica',
  'DJ': 'Djibouti',
  'DK': 'Denmark',
  'VG': 'British Virgin Islands',
  'DE': 'Germany',
  'YE': 'Yemen',
  'DZ': 'Algeria',
  'US': 'United States',
  'UY': 'Uruguay',
  'YT': 'Mayotte',
  'UM': 'United States Minor Outlying Islands',
  'LB': 'Lebanon',
  'LC': 'Saint Lucia',
  'LA': 'Laos',
  'TV': 'Tuvalu',
  'TW': 'Taiwan',
  'TT': 'Trinidad and Tobago',
  'TR': 'Turkey',
  'LK': 'Sri Lanka',
  'LI': 'Liechtenstein',
  'LV': 'Latvia',
  'TO': 'Tonga',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'LR': 'Liberia',
  'LS': 'Lesotho',
  'TH': 'Thailand',
  'TF': 'French Southern Territories',
  'TG': 'Togo',
  'TD': 'Chad',
  'TC': 'Turks and Caicos Islands',
  'LY': 'Libya',
  'VA': 'Vatican',
  'VC': 'Saint Vincent and the Grenadines',
  'AE': 'United Arab Emirates',
  'AD': 'Andorra',
  'AG': 'Antigua and Barbuda',
  'AF': 'Afghanistan',
  'AI': 'Anguilla',
  'VI': 'U.S. Virgin Islands',
  'IS': 'Iceland',
  'IR': 'Iran',
  'AM': 'Armenia',
  'AL': 'Albania',
  'AO': 'Angola',
  'AQ': 'Antarctica',
  'AS': 'American Samoa',
  'AR': 'Argentina',
  'AU': 'Australia',
  'AT': 'Austria',
  'AW': 'Aruba',
  'IN': 'India',
  'AX': 'Aland Islands',
  'AZ': 'Azerbaijan',
  'IE': 'Ireland',
  'ID': 'Indonesia',
  'UA': 'Ukraine',
  'QA': 'Qatar',
  'MZ': 'Mozambique'
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: 'AIzaSyCZTfR3EdNeYJXPxasbafDG302Eno-ECyk',
  authDomain: 'numisma-acfba.firebaseapp.com',
  databaseURL: 'https://numisma-acfba.firebaseio.com',
  projectId: 'numisma-acfba',
  storageBucket: 'numisma-acfba.appspot.com',
  messagingSenderId: '726760483742'
});


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a132b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__(420);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a132b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7554409c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(14)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7554409c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"fas fa-home"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.dashboard'))+"\n    ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",class:{'active': _vm.subIsActive('/coins')},attrs:{"to":"/coins"}},[_c('i',{staticClass:"fas fa-coins"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.coins'))+"\n    ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",class:{'active': _vm.subIsActive('/banknotes')},attrs:{"to":"/banknotes"}},[_c('i',{staticClass:"far fa-money-bill-alt"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.banknotes'))+"\n    ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",class:{'active': _vm.subIsActive('/books')},attrs:{"to":"/books"}},[_c('i',{staticClass:"fas fa-book"}),_vm._v(" "+_vm._s(_vm.$i18n.t('global.books'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('nav',{staticClass:"navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white",attrs:{"id":"sidenav-main"}},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"nav align-items-center d-md-none"},[_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"media align-items-center"},[(_vm.user)?_c('span',{staticClass:"photoURL avatar avatar-sm rounded-circle",style:({ 'background-image': 'url('+_vm.user.photoURL+')' })}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-arrow dropdown-menu-right"},[_c('Menu',{key:"Default"})],1)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"sidenav-collapse-main"}},[_vm._m(2),_vm._v(" "),_c('Nav')],1)])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_vm._t("default")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidenav-collapse-main","aria-controls":"sidenav-main","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand pt-0",attrs:{"href":"#"}},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":__webpack_require__(214),"alt":"Numisma"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-collapse-header d-md-none"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 collapse-brand"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(214)}})])]),_vm._v(" "),_c('div',{staticClass:"col-6 collapse-close"},[_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidenav-collapse-main","aria-controls":"sidenav-main","aria-expanded":"false","aria-label":"Toggle sidenav"}},[_c('span'),_vm._v(" "),_c('span')])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[220]);


// WEBPACK FOOTER //
// static/js/app.556fc546674da260545f.js